// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostData, AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostErrors, AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostResponses, AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostData, AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostErrors, AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostResponses, AcceptSharingInvitationHousesHouseIdSharingAcceptPostData, AcceptSharingInvitationHousesHouseIdSharingAcceptPostErrors, AcceptSharingInvitationHousesHouseIdSharingAcceptPostResponses, ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostData, ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostResponses, AddContactToPropertyHousesHouseIdContactsPostData, AddContactToPropertyHousesHouseIdContactsPostErrors, AddContactToPropertyHousesHouseIdContactsPostResponses, AddTagToDocumentHousesHouseIdDocumentsTagsPostData, AddTagToDocumentHousesHouseIdDocumentsTagsPostErrors, AddTagToDocumentHousesHouseIdDocumentsTagsPostResponses, AddUserToHouseHousesHouseIdUsersPostData, AddUserToHouseHousesHouseIdUsersPostErrors, AddUserToHouseHousesHouseIdUsersPostResponses, AddUserToSharingHousesHouseIdSharingUsersPostData, AddUserToSharingHousesHouseIdSharingUsersPostErrors, AddUserToSharingHousesHouseIdSharingUsersPostResponses, ApproveAccessGrantGuestAccessGrantIdApprovePostData, ApproveAccessGrantGuestAccessGrantIdApprovePostErrors, ApproveAccessGrantGuestAccessGrantIdApprovePostResponses, ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostData, ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostErrors, ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostResponses, ApproveOauthAuthorizeRequestIdApprovePostData, ApproveOauthAuthorizeRequestIdApprovePostErrors, ApproveOauthAuthorizeRequestIdApprovePostResponses, ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostData, ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostErrors, ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostResponses, AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostData, AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostErrors, AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostResponses, AssistantTurnV2HousesHouseIdAssistantTurnPostData, AssistantTurnV2HousesHouseIdAssistantTurnPostErrors, AssistantTurnV2HousesHouseIdAssistantTurnPostResponses, AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostData, AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostErrors, AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostResponses, AuthorizationIsNotHereOauthAuthorizeGetData, AuthorizationIsNotHereOauthAuthorizeGetErrors, AuthorizationIsNotHereOauthAuthorizeGetResponses, AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetData, AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetErrors, AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetResponses, CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteData, CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteErrors, CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteResponses, ChangePasswordMeChangePasswordPostData, ChangePasswordMeChangePasswordPostErrors, ChangePasswordMeChangePasswordPostResponses, CheckResourceStateResourcesResourceIdStateGetData, CheckResourceStateResourcesResourceIdStateGetErrors, CheckResourceStateResourcesResourceIdStateGetResponses, CheckTaskCompletedTasksTaskIdStatusGetData, CheckTaskCompletedTasksTaskIdStatusGetErrors, CheckTaskCompletedTasksTaskIdStatusGetResponses, ClaimPendingPropertyTransferClaimPropertyTransferPostData, ClaimPendingPropertyTransferClaimPropertyTransferPostErrors, ClaimPendingPropertyTransferClaimPropertyTransferPostResponses, CompleteUserAccountMeCompleteAccountPutData, CompleteUserAccountMeCompleteAccountPutErrors, CompleteUserAccountMeCompleteAccountPutResponses, ConfirmOneOffPaymentMePaymentsPostData, ConfirmOneOffPaymentMePaymentsPostErrors, ConfirmOneOffPaymentMePaymentsPostResponses, CreateBillingPortalMeBillingPortalPostData, CreateBillingPortalMeBillingPortalPostResponses, CreateCreditCheckoutCreditsCheckoutPostData, CreateCreditCheckoutCreditsCheckoutPostErrors, CreateCreditCheckoutCreditsCheckoutPostResponses, CreateCustomCategoryServiceCategoriesPostData, CreateCustomCategoryServiceCategoriesPostErrors, CreateCustomCategoryServiceCategoriesPostResponses, CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostData, CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostErrors, CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostResponses, CreateCustomContactRoleHousesHouseIdContactsRolesPostData, CreateCustomContactRoleHousesHouseIdContactsRolesPostErrors, CreateCustomContactRoleHousesHouseIdContactsRolesPostResponses, CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostData, CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostErrors, CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostResponses, CreateGuestInvitationHousesHouseIdGuestAccessInvitePostData, CreateGuestInvitationHousesHouseIdGuestAccessInvitePostErrors, CreateGuestInvitationHousesHouseIdGuestAccessInvitePostResponses, CreateHouseV2V2HousesPostData, CreateHouseV2V2HousesPostErrors, CreateHouseV2V2HousesPostResponses, CreateKeyUsersMeApiKeysPostData, CreateKeyUsersMeApiKeysPostErrors, CreateKeyUsersMeApiKeysPostResponses, CreatePendingPropertyTransferHousesHouseIdPendingTransferPostData, CreatePendingPropertyTransferHousesHouseIdPendingTransferPostErrors, CreatePendingPropertyTransferHousesHouseIdPendingTransferPostResponses, CreateProCheckoutUsersMeProSubscriptionCheckoutPostData, CreateProCheckoutUsersMeProSubscriptionCheckoutPostResponses, CreatePropertyBundleAdminPropertyBundlesPostData, CreatePropertyBundleAdminPropertyBundlesPostErrors, CreatePropertyBundleAdminPropertyBundlesPostResponses, CreateRolloutEndpointObservabilityRolloutsPostData, CreateRolloutEndpointObservabilityRolloutsPostErrors, CreateRolloutEndpointObservabilityRolloutsPostResponses, DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteData, DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteErrors, DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteResponses, DeleteHouseHousesHouseIdDeleteData, DeleteHouseHousesHouseIdDeleteErrors, DeleteHouseHousesHouseIdDeleteResponses, DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteData, DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteErrors, DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteResponses, DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteData, DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteErrors, DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteResponses, DeleteUserUsersUserIdDeleteData, DeleteUserUsersUserIdDeleteErrors, DeleteUserUsersUserIdDeleteResponses, DenyAccessGrantGuestAccessGrantIdDenyPostData, DenyAccessGrantGuestAccessGrantIdDenyPostErrors, DenyAccessGrantGuestAccessGrantIdDenyPostResponses, DenyViaMagicTokenGuestAccessManageDenyViaTokenPostData, DenyViaMagicTokenGuestAccessManageDenyViaTokenPostErrors, DenyViaMagicTokenGuestAccessManageDenyViaTokenPostResponses, DescribeRequestOauthAuthorizeRequestIdGetData, DescribeRequestOauthAuthorizeRequestIdGetErrors, DescribeRequestOauthAuthorizeRequestIdGetResponses, DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetData, DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetErrors, DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetResponses, DrainRekicksEndpointObservabilityRekicksDrainPostData, DrainRekicksEndpointObservabilityRekicksDrainPostErrors, DrainRekicksEndpointObservabilityRekicksDrainPostResponses, EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchData, EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchErrors, EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchResponses, FinalizeHouseSetupHousesHouseIdFinalizePostData, FinalizeHouseSetupHousesHouseIdFinalizePostErrors, FinalizeHouseSetupHousesHouseIdFinalizePostResponses, FinalizeUserFinalizeUserPostData, FinalizeUserFinalizeUserPostErrors, FinalizeUserFinalizeUserPostResponses, ForgotPasswordForgotPasswordPostData, ForgotPasswordForgotPasswordPostErrors, ForgotPasswordForgotPasswordPostResponses, GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostData, GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostErrors, GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostResponses, GetAvailableBundlesPropertyBundlesGetData, GetAvailableBundlesPropertyBundlesGetResponses, GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostData, GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostErrors, GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostResponses, GetBundlePropertyBundlesBundleIdGetData, GetBundlePropertyBundlesBundleIdGetErrors, GetBundlePropertyBundlesBundleIdGetResponses, GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData, GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetErrors, GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetResponses, GetClassificationTagsTagsClassificationsGetData, GetClassificationTagsTagsClassificationsGetErrors, GetClassificationTagsTagsClassificationsGetResponses, GetCreditBalanceCreditsBalanceGetData, GetCreditBalanceCreditsBalanceGetResponses, GetCurrentLegalVersionLegalCurrentVersionGetData, GetCurrentLegalVersionLegalCurrentVersionGetResponses, GetDatabaseConnectionsDiagnosticsDbConnectionsGetData, GetDatabaseConnectionsDiagnosticsDbConnectionsGetResponses, GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData, GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetErrors, GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetResponses, GetDocumentHousesHouseIdDocumentsDocumentIdGetData, GetDocumentHousesHouseIdDocumentsDocumentIdGetErrors, GetDocumentHousesHouseIdDocumentsDocumentIdGetResponses, GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetData, GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetErrors, GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetResponses, GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetData, GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetErrors, GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetResponses, GetFullDiagnosticsDiagnosticsDbFullReportGetData, GetFullDiagnosticsDiagnosticsDbFullReportGetResponses, GetGrantInfoGuestAccessManageInfoGetData, GetGrantInfoGuestAccessManageInfoGetErrors, GetGrantInfoGuestAccessManageInfoGetResponses, GetGuestAccessStatusAccessStatusRequestIdGetData, GetGuestAccessStatusAccessStatusRequestIdGetErrors, GetGuestAccessStatusAccessStatusRequestIdGetResponses, GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetData, GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetErrors, GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetResponses, GetHouseCriticalInfoHousesHouseIdCriticalInfoGetData, GetHouseCriticalInfoHousesHouseIdCriticalInfoGetErrors, GetHouseCriticalInfoHousesHouseIdCriticalInfoGetResponses, GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetData, GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetErrors, GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetResponses, GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetData, GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetErrors, GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetResponses, GetHouseEmailAliasesHousesHouseIdAliasesGetData, GetHouseEmailAliasesHousesHouseIdAliasesGetErrors, GetHouseEmailAliasesHousesHouseIdAliasesGetResponses, GetHouseGrantsHousesHouseIdGuestAccessGrantsGetData, GetHouseGrantsHousesHouseIdGuestAccessGrantsGetErrors, GetHouseGrantsHousesHouseIdGuestAccessGrantsGetResponses, GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetData, GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetErrors, GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetResponses, GetHouseSharingHousesHouseIdSharingGetData, GetHouseSharingHousesHouseIdSharingGetErrors, GetHouseSharingHousesHouseIdSharingGetResponses, GetHousesOfUserUsersUserIdHousesGetData, GetHousesOfUserUsersUserIdHousesGetErrors, GetHousesOfUserUsersUserIdHousesGetResponses, GetHouseTasksHousesHouseIdTasksGetData, GetHouseTasksHousesHouseIdTasksGetErrors, GetHouseTasksHousesHouseIdTasksGetResponses, GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetData, GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetErrors, GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetResponses, GetKeyUsersMeApiKeysPublicIdGetData, GetKeyUsersMeApiKeysPublicIdGetErrors, GetKeyUsersMeApiKeysPublicIdGetResponses, GetLongRunningConnectionsDiagnosticsDbLongRunningGetData, GetLongRunningConnectionsDiagnosticsDbLongRunningGetResponses, GetMagicTokenInfoGuestAccessMagicInfoGetData, GetMagicTokenInfoGuestAccessMagicInfoGetErrors, GetMagicTokenInfoGuestAccessMagicInfoGetResponses, GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData, GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetErrors, GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetResponses, GetMyOutgoingTransfersUsersMeOutgoingTransfersGetData, GetMyOutgoingTransfersUsersMeOutgoingTransfersGetResponses, GetMyPendingTransfersUsersMePendingTransfersGetData, GetMyPendingTransfersUsersMePendingTransfersGetResponses, GetNotificationHousesHouseIdNotificationsNotificationIdGetData, GetNotificationHousesHouseIdNotificationsNotificationIdGetErrors, GetNotificationHousesHouseIdNotificationsNotificationIdGetResponses, GetNotificationsHousesHouseIdNotificationsGetData, GetNotificationsHousesHouseIdNotificationsGetErrors, GetNotificationsHousesHouseIdNotificationsGetResponses, GetPendingPropertyTransferHousesHouseIdPendingTransferGetData, GetPendingPropertyTransferHousesHouseIdPendingTransferGetErrors, GetPendingPropertyTransferHousesHouseIdPendingTransferGetResponses, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetData, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetErrors, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetResponses, GetPendingTransferDetailsPendingTransferTransferTokenGetData, GetPendingTransferDetailsPendingTransferTransferTokenGetErrors, GetPendingTransferDetailsPendingTransferTransferTokenGetResponses, GetPlaceInfoMapsPlacePlaceIdGetData, GetPlaceInfoMapsPlacePlaceIdGetErrors, GetPlaceInfoMapsPlacePlaceIdGetResponses, GetPoolStatsDiagnosticsDbPoolStatsGetData, GetPoolStatsDiagnosticsDbPoolStatsGetResponses, GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetData, GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetErrors, GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetResponses, GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetData, GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetErrors, GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetResponses, GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetData, GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetErrors, GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetResponses, GetResourceTasksResourcesResourceIdTasksGetData, GetResourceTasksResourcesResourceIdTasksGetErrors, GetResourceTasksResourcesResourceIdTasksGetResponses, GetRolloutEndpointObservabilityRolloutsRolloutIdGetData, GetRolloutEndpointObservabilityRolloutsRolloutIdGetErrors, GetRolloutEndpointObservabilityRolloutsRolloutIdGetResponses, GetSavedPaymentMethodMePaymentMethodGetData, GetSavedPaymentMethodMePaymentMethodGetResponses, GetScopeConfigV2HousesHouseIdAssistantConfigGetData, GetScopeConfigV2HousesHouseIdAssistantConfigGetErrors, GetScopeConfigV2HousesHouseIdAssistantConfigGetResponses, GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetData, GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetErrors, GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetResponses, GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetData, GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetErrors, GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetResponses, GetSystemResourcesDiagnosticsSystemResourcesGetData, GetSystemResourcesDiagnosticsSystemResourcesGetResponses, GetTaskStatusPaginatedTasksStatusGetData, GetTaskStatusPaginatedTasksStatusGetErrors, GetTaskStatusPaginatedTasksStatusGetResponses, GetUserActivityHousesHouseIdUsersUserIdActivityGetData, GetUserActivityHousesHouseIdUsersUserIdActivityGetErrors, GetUserActivityHousesHouseIdUsersUserIdActivityGetResponses, GetUserCreditsAdminAdminUsersUserIdCreditsGetData, GetUserCreditsAdminAdminUsersUserIdCreditsGetErrors, GetUserCreditsAdminAdminUsersUserIdCreditsGetResponses, GetUsersOfHouseHousesHouseIdUsersGetData, GetUsersOfHouseHousesHouseIdUsersGetErrors, GetUsersOfHouseHousesHouseIdUsersGetResponses, GetUserUsersUserIdGetData, GetUserUsersUserIdGetErrors, GetUserUsersUserIdGetResponses, GoogleLoginGoogleTokenPostData, GoogleLoginGoogleTokenPostErrors, GoogleLoginGoogleTokenPostResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, InboundEmailHooksPostmarkInboundPostData, InboundEmailHooksPostmarkInboundPostErrors, InboundEmailHooksPostmarkInboundPostResponses, IngestDeployObservabilityDeploysPostData, IngestDeployObservabilityDeploysPostErrors, IngestDeployObservabilityDeploysPostResponses, InteractivityObservabilitySlackInteractivityPostData, InteractivityObservabilitySlackInteractivityPostResponses, InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostData, InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostErrors, InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostResponses, ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetData, ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetErrors, ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetResponses, ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetData, ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetErrors, ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetResponses, ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetData, ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetErrors, ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetResponses, ListContactCandidatesHousesHouseIdContactsCandidatesGetData, ListContactCandidatesHousesHouseIdContactsCandidatesGetErrors, ListContactCandidatesHousesHouseIdContactsCandidatesGetResponses, ListContactTaxonomyHousesHouseIdContactsTaxonomyGetData, ListContactTaxonomyHousesHouseIdContactsTaxonomyGetErrors, ListContactTaxonomyHousesHouseIdContactsTaxonomyGetResponses, ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetData, ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetErrors, ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetResponses, ListDocumentsHousesHouseIdDocumentsGetData, ListDocumentsHousesHouseIdDocumentsGetErrors, ListDocumentsHousesHouseIdDocumentsGetResponses, ListFeedbackV2HousesHouseIdAssistantFeedbackGetData, ListFeedbackV2HousesHouseIdAssistantFeedbackGetErrors, ListFeedbackV2HousesHouseIdAssistantFeedbackGetResponses, ListGrantableScopesUsersMeApiKeysScopesGetData, ListGrantableScopesUsersMeApiKeysScopesGetErrors, ListGrantableScopesUsersMeApiKeysScopesGetResponses, ListHouseCorrectionsHousesHouseIdCorrectionsGetData, ListHouseCorrectionsHousesHouseIdCorrectionsGetErrors, ListHouseCorrectionsHousesHouseIdCorrectionsGetResponses, ListKeysUsersMeApiKeysGetData, ListKeysUsersMeApiKeysGetErrors, ListKeysUsersMeApiKeysGetResponses, ListPropertyContactsHousesHouseIdContactsGetData, ListPropertyContactsHousesHouseIdContactsGetErrors, ListPropertyContactsHousesHouseIdContactsGetResponses, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetData, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetErrors, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetResponses, ListRolloutsEndpointObservabilityRolloutsGetData, ListRolloutsEndpointObservabilityRolloutsGetResponses, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetData, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetErrors, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetResponses, ListServiceCategoriesServiceCategoriesGetData, ListServiceCategoriesServiceCategoriesGetResponses, ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetData, ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetErrors, ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetResponses, ListStagedDocumentsHousesHouseIdStagedDocumentsGetData, ListStagedDocumentsHousesHouseIdStagedDocumentsGetErrors, ListStagedDocumentsHousesHouseIdStagedDocumentsGetResponses, LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostData, LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostErrors, LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostResponses, LoginForAccessTokenTokenPostData, LoginForAccessTokenTokenPostErrors, LoginForAccessTokenTokenPostResponses, ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutData, ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutErrors, ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutResponses, MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostData, MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostErrors, MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostResponses, PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostData, PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostErrors, PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostResponses, PostPlanActionV2HousesHouseIdMaintenanceActionsPostData, PostPlanActionV2HousesHouseIdMaintenanceActionsPostErrors, PostPlanActionV2HousesHouseIdMaintenanceActionsPostResponses, PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostData, PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostErrors, PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostResponses, PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostData, PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostErrors, PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostResponses, PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostData, PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostErrors, PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostResponses, QrLandingPageQrPropertyPublicIdGetData, QrLandingPageQrPropertyPublicIdGetErrors, QrLandingPageQrPropertyPublicIdGetResponses, ReadHouseHousesHouseIdGetData, ReadHouseHousesHouseIdGetErrors, ReadHouseHousesHouseIdGetResponses, ReadHousesHousesGetData, ReadHousesHousesGetErrors, ReadHousesHousesGetResponses, ReadinessCheckGreenthumbGetData, ReadinessCheckGreenthumbGetResponses, ReadRegistrationOauthRegisterClientIdGetData, ReadRegistrationOauthRegisterClientIdGetErrors, ReadRegistrationOauthRegisterClientIdGetResponses, ReadRootGetData, ReadRootGetResponses, ReadUsersMeUsersMeGetData, ReadUsersMeUsersMeGetResponses, ReadUsersUsersGetData, ReadUsersUsersGetErrors, ReadUsersUsersGetResponses, RedeemMagicTokenGuestAccessMagicRedeemPostData, RedeemMagicTokenGuestAccessMagicRedeemPostErrors, RedeemMagicTokenGuestAccessMagicRedeemPostResponses, RefreshAccessTokenTokenRefreshPostData, RefreshAccessTokenTokenRefreshPostErrors, RefreshAccessTokenTokenRefreshPostResponses, RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostData, RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostErrors, RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostResponses, RefuseOauthAuthorizeRequestIdRefusePostData, RefuseOauthAuthorizeRequestIdRefusePostErrors, RefuseOauthAuthorizeRequestIdRefusePostResponses, RegisterGoogleUserUsersGooglePostData, RegisterGoogleUserUsersGooglePostErrors, RegisterGoogleUserUsersGooglePostResponses, RegisterOauthRegisterPostData, RegisterOauthRegisterPostErrors, RegisterOauthRegisterPostResponses, RegisterUserUsersPostData, RegisterUserUsersPostErrors, RegisterUserUsersPostResponses, RegistrationIsNotEditableOauthRegisterClientIdPutData, RegistrationIsNotEditableOauthRegisterClientIdPutErrors, RegistrationIsNotEditableOauthRegisterClientIdPutResponses, RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostData, RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostErrors, RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostResponses, RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostData, RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostErrors, RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostResponses, RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostData, RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostErrors, RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostResponses, ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostData, ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostErrors, ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostResponses, RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteData, RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteErrors, RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteResponses, RemoveRegistrationOauthRegisterClientIdDeleteData, RemoveRegistrationOauthRegisterClientIdDeleteErrors, RemoveRegistrationOauthRegisterClientIdDeleteResponses, RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteData, RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteErrors, RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteResponses, RemoveTagFromDocumentDocumentsTagsDeleteData, RemoveTagFromDocumentDocumentsTagsDeleteErrors, RemoveTagFromDocumentDocumentsTagsDeleteResponses, RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteData, RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteErrors, RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteResponses, ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutData, ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutErrors, ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutResponses, RequestGuestAccessHousesHouseIdAccessRequestPostData, RequestGuestAccessHousesHouseIdAccessRequestPostErrors, RequestGuestAccessHousesHouseIdAccessRequestPostResponses, RequestGuestCodeGuestAccessMagicCodePostData, RequestGuestCodeGuestAccessMagicCodePostErrors, RequestGuestCodeGuestAccessMagicCodePostResponses, ResetPasswordResetPasswordPostData, ResetPasswordResetPasswordPostErrors, ResetPasswordResetPasswordPostResponses, RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostData, RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostErrors, RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostResponses, ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostData, ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostErrors, ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostResponses, RetryTransferFinalizationPendingTransferTransferIdRetryPostData, RetryTransferFinalizationPendingTransferTransferIdRetryPostErrors, RetryTransferFinalizationPendingTransferTransferIdRetryPostResponses, RevokeKeyUsersMeApiKeysPublicIdDeleteData, RevokeKeyUsersMeApiKeysPublicIdDeleteErrors, RevokeKeyUsersMeApiKeysPublicIdDeleteResponses, RevokeOauthRevokePostData, RevokeOauthRevokePostErrors, RevokeOauthRevokePostResponses, RunStressTestDiagnosticsDbStressTestPostData, RunStressTestDiagnosticsDbStressTestPostErrors, RunStressTestDiagnosticsDbStressTestPostResponses, SearchPlacesMapsAutocompleteGetData, SearchPlacesMapsAutocompleteGetErrors, SearchPlacesMapsAutocompleteGetResponses, SendWelcomeEmailEndpointHousesHouseIdOnboardedPostData, SendWelcomeEmailEndpointHousesHouseIdOnboardedPostErrors, SendWelcomeEmailEndpointHousesHouseIdOnboardedPostResponses, ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostData, ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostErrors, ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostResponses, SlashCommandObservabilitySlackCommandPostData, SlashCommandObservabilitySlackCommandPostResponses, StartAuthorizationOauthAuthorizePostData, StartAuthorizationOauthAuthorizePostErrors, StartAuthorizationOauthAuthorizePostResponses, StripeWebhookStripeWebhookPostData, StripeWebhookStripeWebhookPostResponses, SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostData, SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostErrors, SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostResponses, SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostData, SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostErrors, SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostResponses, TokenOauthTokenPostData, TokenOauthTokenPostErrors, TokenOauthTokenPostResponses, UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostData, UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostErrors, UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostResponses, UpdateDocumentHousesHouseIdDocumentsDocumentIdPutData, UpdateDocumentHousesHouseIdDocumentsDocumentIdPutErrors, UpdateDocumentHousesHouseIdDocumentsDocumentIdPutResponses, UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchData, UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchErrors, UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchResponses, UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutData, UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutErrors, UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutResponses, UpdateHouseHousesHouseIdPutData, UpdateHouseHousesHouseIdPutErrors, UpdateHouseHousesHouseIdPutResponses, UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutData, UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutErrors, UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutResponses, UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutData, UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutErrors, UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutResponses, UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchData, UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchErrors, UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchResponses, UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchData, UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchErrors, UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchResponses, UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchData, UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchErrors, UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchResponses, UpdateTosAcceptanceMeTosAcceptancePutData, UpdateTosAcceptanceMeTosAcceptancePutErrors, UpdateTosAcceptanceMeTosAcceptancePutResponses, UpdateUserUsersUserIdPutData, UpdateUserUsersUserIdPutErrors, UpdateUserUsersUserIdPutResponses, UploadDocumentsV2V2HousesHouseIdDocumentsPostData, UploadDocumentsV2V2HousesHouseIdDocumentsPostErrors, UploadDocumentsV2V2HousesHouseIdDocumentsPostResponses, UpsertScopeConfigV2HousesHouseIdAssistantConfigPutData, UpsertScopeConfigV2HousesHouseIdAssistantConfigPutErrors, UpsertScopeConfigV2HousesHouseIdAssistantConfigPutResponses, VerifyCreditPurchaseCreditsVerifyPurchasePostData, VerifyCreditPurchaseCreditsVerifyPurchasePostErrors, VerifyCreditPurchaseCreditsVerifyPurchasePostResponses, VerifyGuestCodeGuestAccessMagicVerifyPostData, VerifyGuestCodeGuestAccessMagicVerifyPostErrors, VerifyGuestCodeGuestAccessMagicVerifyPostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class AssistantV2 {
    /**
     * Assistant Turn
     */
    public static assistantTurnV2HousesHouseIdAssistantTurnPost<ThrowOnError extends boolean = false>(options: Options<AssistantTurnV2HousesHouseIdAssistantTurnPostData, ThrowOnError>) {
        return (options.client ?? client).post<AssistantTurnV2HousesHouseIdAssistantTurnPostResponses, AssistantTurnV2HousesHouseIdAssistantTurnPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/turn',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Assistant Turn Stream
     */
    public static assistantTurnStreamV2HousesHouseIdAssistantTurnStreamPost<ThrowOnError extends boolean = false>(options: Options<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostData, ThrowOnError>) {
        return (options.client ?? client).post<AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostResponses, AssistantTurnStreamV2HousesHouseIdAssistantTurnStreamPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/turn/stream',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Assistant Sessions
     */
    public static listAssistantSessionsV2HousesHouseIdAssistantSessionsGet<ThrowOnError extends boolean = false>(options: Options<ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetResponses, ListAssistantSessionsV2HousesHouseIdAssistantSessionsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/sessions',
            ...options
        });
    }
    
    /**
     * List Session Exchanges
     */
    public static listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGet<ThrowOnError extends boolean = false>(options: Options<ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetResponses, ListSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/sessions/{session_id}/exchanges',
            ...options
        });
    }
    
    /**
     * List Feedback
     *
     * List full feedback records for a house — **admin/internal only**.
     *
     * This is the operational/admin view: it returns complete records (incl. comments and other
     * users' feedback) and is the place that may grow to include more metadata. Normal users do NOT
     * get a feedback-listing endpoint; they hydrate their own thumb state via
     * `GET .../assistant/feedback/state` instead.
     *
     * - Filter by rating with ?rating=thumbs_up or ?rating=thumbs_down.
     * - Results are ordered most-recent first (by id desc).
     * - Paginate with ?cursor=<last_feedback_id> to get the next page.
     */
    public static listFeedbackV2HousesHouseIdAssistantFeedbackGet<ThrowOnError extends boolean = false>(options: Options<ListFeedbackV2HousesHouseIdAssistantFeedbackGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListFeedbackV2HousesHouseIdAssistantFeedbackGetResponses, ListFeedbackV2HousesHouseIdAssistantFeedbackGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/feedback',
            ...options
        });
    }
    
    /**
     * Submit Feedback
     *
     * Submit explicit feedback (thumbs up/down) for an assistant exchange.
     *
     * - Requires ASSISTANT_QUERY on the house (any member who can use the assistant).
     * - exchange_id must belong to the authenticated user for this house.
     * - Duplicate submissions for the same exchange_id are idempotent: the
     * original feedback record is returned unchanged.
     * - On thumbs_down, the pending Redis trace (if available) is promoted to
     * durable storage and trace_captured=True is returned.
     */
    public static submitFeedbackV2HousesHouseIdAssistantFeedbackPost<ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostData, ThrowOnError>) {
        return (options.client ?? client).post<SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostResponses, SubmitFeedbackV2HousesHouseIdAssistantFeedbackPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/feedback',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Feedback State
     *
     * The current user's feedback state on this house — (exchange_id, rating) pairs only.
     *
     * Used by the client to render thumbs as already-rated. Deliberately minimal: no comments, no
     * metadata, no other users' feedback — that is the admin-only `list_feedback` endpoint's job. This
     * keeps the normal-user surface as lightweight feedback *state*, not feedback *browsing*.
     */
    public static getFeedbackStateV2HousesHouseIdAssistantFeedbackStateGet<ThrowOnError extends boolean = false>(options: Options<GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetResponses, GetFeedbackStateV2HousesHouseIdAssistantFeedbackStateGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/feedback/state',
            ...options
        });
    }
    
    /**
     * Get Exchange Trace
     *
     * Return the promoted debug trace for an exchange (admin only).
     *
     * Returns 404 if no trace has been promoted for this exchange (i.e. no
     * thumbs_down feedback was submitted while a pending trace was buffered).
     */
    public static getExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGet<ThrowOnError extends boolean = false>(options: Options<GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetResponses, GetExchangeTraceV2HousesHouseIdAssistantExchangesExchangeIdTraceGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/exchanges/{exchange_id}/trace',
            ...options
        });
    }
    
    /**
     * Delete Scope Config
     *
     * Delete the RAG scope config override for a house, reverting to code defaults.
     */
    public static deleteScopeConfigV2HousesHouseIdAssistantConfigDelete<ThrowOnError extends boolean = false>(options: Options<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteResponses, DeleteScopeConfigV2HousesHouseIdAssistantConfigDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/config',
            ...options
        });
    }
    
    /**
     * Get Scope Config
     *
     * Return the RAG scope config for a house. Returns 404 if no override is set.
     */
    public static getScopeConfigV2HousesHouseIdAssistantConfigGet<ThrowOnError extends boolean = false>(options: Options<GetScopeConfigV2HousesHouseIdAssistantConfigGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetScopeConfigV2HousesHouseIdAssistantConfigGetResponses, GetScopeConfigV2HousesHouseIdAssistantConfigGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/config',
            ...options
        });
    }
    
    /**
     * Upsert Scope Config
     *
     * Create or update the RAG scope config for a house.
     *
     * Passing system_prompt=null clears the override (deletes the row) and
     * reverts to code defaults, equivalent to calling DELETE.
     */
    public static upsertScopeConfigV2HousesHouseIdAssistantConfigPut<ThrowOnError extends boolean = false>(options: Options<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpsertScopeConfigV2HousesHouseIdAssistantConfigPutResponses, UpsertScopeConfigV2HousesHouseIdAssistantConfigPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/assistant/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Users {
    /**
     * Read Users
     */
    public static readUsersUsersGet<ThrowOnError extends boolean = false>(options?: Options<ReadUsersUsersGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ReadUsersUsersGetResponses, ReadUsersUsersGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users',
            ...options
        });
    }
    
    /**
     * Change Password
     */
    public static changePasswordMeChangePasswordPost<ThrowOnError extends boolean = false>(options: Options<ChangePasswordMeChangePasswordPostData, ThrowOnError>) {
        return (options.client ?? client).post<ChangePasswordMeChangePasswordPostResponses, ChangePasswordMeChangePasswordPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/me/change-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read Users Me
     */
    public static readUsersMeUsersMeGet<ThrowOnError extends boolean = false>(options?: Options<ReadUsersMeUsersMeGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ReadUsersMeUsersMeGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me',
            ...options
        });
    }
    
    /**
     * Delete User
     */
    public static deleteUserUsersUserIdDelete<ThrowOnError extends boolean = false>(options: Options<DeleteUserUsersUserIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteUserUsersUserIdDeleteResponses, DeleteUserUsersUserIdDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Get User
     */
    public static getUserUsersUserIdGet<ThrowOnError extends boolean = false>(options: Options<GetUserUsersUserIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetUserUsersUserIdGetResponses, GetUserUsersUserIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Update User
     */
    public static updateUserUsersUserIdPut<ThrowOnError extends boolean = false>(options: Options<UpdateUserUsersUserIdPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdateUserUsersUserIdPutResponses, UpdateUserUsersUserIdPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Houses Of User
     *
     * Get all houses associated with a user.
     *
     * Parameters:
     * - user_id (int): ID of the user whose houses to retrieve.
     * - db (AsyncSession): Database session.
     * - current_user (users.models.User): Current authenticated user.
     */
    public static getHousesOfUserUsersUserIdHousesGet<ThrowOnError extends boolean = false>(options: Options<GetHousesOfUserUsersUserIdHousesGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHousesOfUserUsersUserIdHousesGetResponses, GetHousesOfUserUsersUserIdHousesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}/houses',
            ...options
        });
    }
    
    /**
     * Get My Pending Transfers
     *
     * Get all pending property transfers for the current user.
     *
     * Returns a list of properties that have been offered to the user
     * but haven't been claimed yet. Useful for:
     * - Dashboard notifications
     * - Onboarding flows
     * - Property invitation management
     */
    public static getMyPendingTransfersUsersMePendingTransfersGet<ThrowOnError extends boolean = false>(options?: Options<GetMyPendingTransfersUsersMePendingTransfersGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetMyPendingTransfersUsersMePendingTransfersGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/pending-transfers',
            ...options
        });
    }
    
    /**
     * Get My Outgoing Transfers
     *
     * Get all outstanding outgoing property transfers the current user has initiated.
     *
     * Aggregates what GET /houses/{house_id}/pending-transfer returns per property, across every
     * property the user owns, in one call. Outstanding = status in (pending, processing, failed) —
     * in-flight or failed-and-retryable; completed/cancelled/expired are excluded. Returns [] (200)
     * when there are none — never 404 — so the FE badge query stays clean.
     */
    public static getMyOutgoingTransfersUsersMeOutgoingTransfersGet<ThrowOnError extends boolean = false>(options?: Options<GetMyOutgoingTransfersUsersMeOutgoingTransfersGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetMyOutgoingTransfersUsersMeOutgoingTransfersGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/outgoing-transfers',
            ...options
        });
    }
    
    /**
     * Create Pro Checkout
     *
     * Create a Stripe checkout session for the Pro subscription.
     *
     * Available to any authenticated user who does not already have an active subscription.
     * The frontend should redirect the user to the returned checkout_url to complete payment.
     */
    public static createProCheckoutUsersMeProSubscriptionCheckoutPost<ThrowOnError extends boolean = false>(options?: Options<CreateProCheckoutUsersMeProSubscriptionCheckoutPostData, ThrowOnError>) {
        return (options?.client ?? client).post<CreateProCheckoutUsersMeProSubscriptionCheckoutPostResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/pro-subscription/checkout',
            ...options
        });
    }
    
    /**
     * Activate Pro Subscription Direct
     *
     * Activate a Pro subscription using the user's saved card.
     *
     * Skips the Stripe-hosted checkout redirect when a saved PaymentMethod is on file.
     * The frontend shows a confirmation modal first; this endpoint is called only after
     * explicit user confirmation.
     *
     * Returns status='active' when payment succeeds immediately.
     * Returns status='requires_action' with a redirect_url when the card requires 3DS;
     * after authentication Stripe activates the subscription via webhook.
     *
     * Returns HTTP 400 if no saved card is on file — the frontend should fall back to
     * POST /users/me/pro-subscription/checkout instead.
     */
    public static activateProSubscriptionDirectUsersMeProSubscriptionActivatePost<ThrowOnError extends boolean = false>(options?: Options<ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostData, ThrowOnError>) {
        return (options?.client ?? client).post<ActivateProSubscriptionDirectUsersMeProSubscriptionActivatePostResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/pro-subscription/activate',
            ...options
        });
    }
    
    /**
     * Update Tos Acceptance
     *
     * Update user's Terms of Service acceptance.
     *
     * This endpoint allows authenticated users to update their ToS acceptance status
     * with a specific version and timestamp. The version must match the currently
     * active legal version.
     *
     * Args:
     * request_data: Contains tos_version and optional tos_agreed_at
     * current_user: Currently authenticated user
     * db: Database session
     *
     * Returns:
     * Confirmation with updated tos_version and tos_agreed_at
     *
     * Raises:
     * HTTPException 400: If no active legal version exists or version doesn't match
     */
    public static updateTosAcceptanceMeTosAcceptancePut<ThrowOnError extends boolean = false>(options: Options<UpdateTosAcceptanceMeTosAcceptancePutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdateTosAcceptanceMeTosAcceptancePutResponses, UpdateTosAcceptanceMeTosAcceptancePutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/me/tos-acceptance',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Complete User Account
     *
     * Complete user account setup with TOS and marketing consent.
     *
     * This endpoint is specifically for Google users who have already authenticated
     * but need to accept terms and provide marketing consent. It's the equivalent
     * of the finalize_user flow but for already-authenticated Google users.
     *
     * Args:
     * request_data: Contains tos_version, marketing_consent and optional timestamps
     * current_user: Currently authenticated user
     * db: Database session
     *
     * Returns:
     * Confirmation with updated TOS, marketing consent, and user data
     *
     * Raises:
     * HTTPException 400: If user has already completed account setup or TOS validation fails
     */
    public static completeUserAccountMeCompleteAccountPut<ThrowOnError extends boolean = false>(options: Options<CompleteUserAccountMeCompleteAccountPutData, ThrowOnError>) {
        return (options.client ?? client).put<CompleteUserAccountMeCompleteAccountPutResponses, CompleteUserAccountMeCompleteAccountPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/me/complete-account',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Saved Payment Method
     *
     * Return display info for the user's saved card (brand, last4, expiry).
     *
     * Used by the frontend to render a confirmation dialog before charging.
     * No sensitive card data is stored in our database — all info is fetched
     * live from Stripe via the stored PaymentMethod ID.
     *
     * Returns:
     * SavedPaymentMethodResponse with has_saved_card=False if no card is saved.
     * If has_saved_card=False, fall back to the standard Checkout redirect flow.
     */
    public static getSavedPaymentMethodMePaymentMethodGet<ThrowOnError extends boolean = false>(options?: Options<GetSavedPaymentMethodMePaymentMethodGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetSavedPaymentMethodMePaymentMethodGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/me/payment-method',
            ...options
        });
    }
    
    /**
     * Create Billing Portal
     *
     * Create a Stripe Customer Portal session.
     *
     * Redirects the user to Stripe's hosted portal where they can update their
     * payment method, manage their subscription, and download invoices.
     * Returns 400 when the user has no Stripe customer record — this means they
     * have never completed a checkout and have nothing to manage.
     */
    public static createBillingPortalMeBillingPortalPost<ThrowOnError extends boolean = false>(options?: Options<CreateBillingPortalMeBillingPortalPostData, ThrowOnError>) {
        return (options?.client ?? client).post<CreateBillingPortalMeBillingPortalPostResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/me/billing-portal',
            ...options
        });
    }
    
    /**
     * Confirm One Off Payment
     *
     * Charge the user's saved card after explicit frontend confirmation.
     *
     * The frontend must call GET /me/payment-method first to display a
     * confirmation dialog showing the card details to the user. Only after
     * the user confirms should this endpoint be called.
     *
     * If the card requires 3DS/SCA authentication, status='requires_action'
     * is returned with a redirect_url the frontend must redirect the user to.
     * After authentication Stripe redirects back to payload.return_url.
     *
     * If no saved card is on file, returns HTTP 400 — the frontend should fall
     * back to the existing Checkout redirect flow.
     *
     * Returns:
     * OneOffPaymentResponse with status 'succeeded' or 'requires_action'.
     */
    public static confirmOneOffPaymentMePaymentsPost<ThrowOnError extends boolean = false>(options: Options<ConfirmOneOffPaymentMePaymentsPostData, ThrowOnError>) {
        return (options.client ?? client).post<ConfirmOneOffPaymentMePaymentsPostResponses, ConfirmOneOffPaymentMePaymentsPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/me/payments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class UserRegistration {
    /**
     * Register User
     */
    public static registerUserUsersPost<ThrowOnError extends boolean = false>(options: Options<RegisterUserUsersPostData, ThrowOnError>) {
        return (options.client ?? client).post<RegisterUserUsersPostResponses, RegisterUserUsersPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Register Google User
     */
    public static registerGoogleUserUsersGooglePost<ThrowOnError extends boolean = false>(options: Options<RegisterGoogleUserUsersGooglePostData, ThrowOnError>) {
        return (options.client ?? client).post<RegisterGoogleUserUsersGooglePostResponses, RegisterGoogleUserUsersGooglePostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/users/google',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Finalize User
     */
    public static finalizeUserFinalizeUserPost<ThrowOnError extends boolean = false>(options: Options<FinalizeUserFinalizeUserPostData, ThrowOnError>) {
        return (options.client ?? client).post<FinalizeUserFinalizeUserPostResponses, FinalizeUserFinalizeUserPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/finalize-user',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Forgot Password
     *
     * Initiate password reset process by sending reset email.
     *
     * This endpoint:
     * - Validates email exists and is verified
     * - Generates secure reset token
     * - Sends password reset email
     * - Rate limits to prevent abuse
     *
     * Args:
     * request_data: Contains email address
     * request: FastAPI request object for IP/user agent
     *
     * Returns:
     * Success message (same response regardless of email validity for security)
     *
     * Raises:
     * UserNotFoundError: If user not found
     * UserNotVerifiedError: If user exists but is not verified
     */
    public static forgotPasswordForgotPasswordPost<ThrowOnError extends boolean = false>(options: Options<ForgotPasswordForgotPasswordPostData, ThrowOnError>) {
        return (options.client ?? client).post<ForgotPasswordForgotPasswordPostResponses, ForgotPasswordForgotPasswordPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/forgot-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reset Password
     *
     * Complete password reset using valid token.
     *
     * This endpoint:
     * - Verifies reset token is valid and not expired
     * - Updates user password with secure hash
     * - Marks token as used
     * - Invalidates all other tokens for the user
     *
     * Args:
     * request_data: Contains reset token and new password
     *
     * Returns:
     * Success confirmation with email
     *
     * Raises:
     * HTTPException: If token is invalid or expired
     */
    public static resetPasswordResetPasswordPost<ThrowOnError extends boolean = false>(options: Options<ResetPasswordResetPasswordPostData, ThrowOnError>) {
        return (options.client ?? client).post<ResetPasswordResetPasswordPostResponses, ResetPasswordResetPasswordPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/reset-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Properties {
    /**
     * Create House V2
     *
     * Create a new house using the credit-based payment system (v2).
     *
     * This endpoint:
     * - Validates the user has available property credits
     * - Consumes one credit from the user's balance
     * - Creates the house with proper ownership tracking
     * - Sets up a property-level subscription
     * - Creates ownership history record
     *
     * Returns 402 Payment Required if user has insufficient credits.
     */
    public static createHouseV2V2HousesPost<ThrowOnError extends boolean = false>(options: Options<CreateHouseV2V2HousesPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateHouseV2V2HousesPostResponses, CreateHouseV2V2HousesPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete House
     */
    public static deleteHouseHousesHouseIdDelete<ThrowOnError extends boolean = false>(options: Options<DeleteHouseHousesHouseIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteHouseHousesHouseIdDeleteResponses, DeleteHouseHousesHouseIdDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}',
            ...options
        });
    }
    
    /**
     * Read House
     */
    public static readHouseHousesHouseIdGet<ThrowOnError extends boolean = false>(options: Options<ReadHouseHousesHouseIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<ReadHouseHousesHouseIdGetResponses, ReadHouseHousesHouseIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}',
            ...options
        });
    }
    
    /**
     * Update House
     *
     * Update an existing house.
     */
    public static updateHouseHousesHouseIdPut<ThrowOnError extends boolean = false>(options: Options<UpdateHouseHousesHouseIdPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdateHouseHousesHouseIdPutResponses, UpdateHouseHousesHouseIdPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read Houses
     *
     * Enhanced houses endpoint for all user roles.
     *
     * Returns:
     * - For admins: All houses
     * - For homeowners/builders: Houses via HouseUserAssociation
     * - For professionals: Houses where they are contacts + houses via association
     */
    public static readHousesHousesGet<ThrowOnError extends boolean = false>(options?: Options<ReadHousesHousesGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ReadHousesHousesGetResponses, ReadHousesHousesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses',
            ...options
        });
    }
    
    /**
     * Get Users Of House
     */
    public static getUsersOfHouseHousesHouseIdUsersGet<ThrowOnError extends boolean = false>(options: Options<GetUsersOfHouseHousesHouseIdUsersGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetUsersOfHouseHousesHouseIdUsersGetResponses, GetUsersOfHouseHousesHouseIdUsersGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/users',
            ...options
        });
    }
    
    /**
     * Add User To House
     *
     * Add a user to a house.
     */
    public static addUserToHouseHousesHouseIdUsersPost<ThrowOnError extends boolean = false>(options: Options<AddUserToHouseHousesHouseIdUsersPostData, ThrowOnError>) {
        return (options.client ?? client).post<AddUserToHouseHousesHouseIdUsersPostResponses, AddUserToHouseHousesHouseIdUsersPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove User From House
     *
     * Remove a user from a house.
     */
    public static removeUserFromHouseHousesHouseIdUsersUserIdDelete<ThrowOnError extends boolean = false>(options: Options<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteResponses, RemoveUserFromHouseHousesHouseIdUsersUserIdDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Get House Email Aliases
     *
     * Get all email aliases for a house.
     *
     * Returns a list of email aliases associated with the property,
     * which can be used for inbound email routing (e.g., 60nikau@upload.mybundle.app).
     *
     * Args:
     * house_id: The ID of the house
     * db: Database session
     * current_user: The current authenticated user
     *
     * Returns:
     * List of HouseEmailAlias schemas
     *
     * Raises:
     * HTTPException: 404 if house not found, 403 if user lacks access
     */
    public static getHouseEmailAliasesHousesHouseIdAliasesGet<ThrowOnError extends boolean = false>(options: Options<GetHouseEmailAliasesHousesHouseIdAliasesGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHouseEmailAliasesHousesHouseIdAliasesGetResponses, GetHouseEmailAliasesHousesHouseIdAliasesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/aliases',
            ...options
        });
    }
    
    /**
     * Get Property Payment Status
     *
     * Get payment status information for a specific property.
     *
     * Returns detailed payment and subscription information including:
     * - Payment status (active, failed, exempted, etc.)
     * - Current payer information
     * - Subscription expiration and grace periods
     * - Payment mode (credit_based, grandfathered, etc.)
     */
    public static getPropertyPaymentStatusHousesHouseIdPaymentStatusGet<ThrowOnError extends boolean = false>(options: Options<GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetResponses, GetPropertyPaymentStatusHousesHouseIdPaymentStatusGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/payment-status',
            ...options
        });
    }
    
    /**
     * Get Guest Qr Code Image
     *
     * Retrieve the QR code image for the guest access URL of a house.
     *
     * Args:
     * house_id (int): The ID of the house.
     * db (AsyncSession): The async database session.
     * current_user (User): The current authenticated user.
     *
     * Returns:
     * Response: The QR code image as a stream or a 404 error if not found.
     */
    public static getGuestQrCodeImageHousesHouseIdQrCodeGuestGet<ThrowOnError extends boolean = false>(options: Options<GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetResponses, GetGuestQrCodeImageHousesHouseIdQrCodeGuestGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/qr-code/guest',
            ...options
        });
    }
    
    /**
     * Generate Qr Code Endpoint
     *
     * Endpoint to trigger QR code generation for a house.
     *
     * Args:
     * house_id (int): The ID of the house.
     * background_tasks (BackgroundTasks): Background task manager for async task execution.
     * db (AsyncSession): The database session dependency.
     * current_user (User): The current authenticated user.
     *
     * Returns:
     * dict: Success message or error details.
     */
    public static generateQrCodeEndpointHousesHouseIdQrCodeGuestPost<ThrowOnError extends boolean = false>(options: Options<GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostData, ThrowOnError>) {
        return (options.client ?? client).post<GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostResponses, GenerateQrCodeEndpointHousesHouseIdQrCodeGuestPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/qr-code/guest',
            ...options
        });
    }
    
    /**
     * Get Qr Code Settings Endpoint
     */
    public static getQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGet<ThrowOnError extends boolean = false>(options: Options<GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetResponses, GetQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/qr-code/guest/settings',
            ...options
        });
    }
    
    /**
     * Update Qr Code Settings Endpoint
     */
    public static updateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatch<ThrowOnError extends boolean = false>(options: Options<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchResponses, UpdateQrCodeSettingsEndpointHousesHouseIdQrCodeGuestSettingsPatchErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/qr-code/guest/settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Qr Codes Endpoint
     *
     * Endpoint to trigger deletion of all QR codes for a house.
     *
     * Args:
     * house_id (int): The ID of the house.
     * background_tasks (BackgroundTasks): Background task manager for async task execution.
     * db (AsyncSession): The database session dependency.
     * current_user (User): The current authenticated user.
     *
     * Returns:
     * dict: Success message or error details.
     */
    public static deleteQrCodesEndpointHousesHouseIdQrCodesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteResponses, DeleteQrCodesEndpointHousesHouseIdQrCodesDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/qr-codes',
            ...options
        });
    }
    
    /**
     * Send Welcome Email Endpoint
     *
     * Send a welcome email to the property owner and mark the house as onboarded.
     *
     * This endpoint:
     * - Validates property access
     * - Sends welcome email to the current owner
     * - Updates the house onboarded status to True
     *
     * Args:
     * house_id: ID of the property
     *
     * Returns:
     * WelcomeEmailResponse: Confirmation with email details
     */
    public static sendWelcomeEmailEndpointHousesHouseIdOnboardedPost<ThrowOnError extends boolean = false>(options: Options<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostData, ThrowOnError>) {
        return (options.client ?? client).post<SendWelcomeEmailEndpointHousesHouseIdOnboardedPostResponses, SendWelcomeEmailEndpointHousesHouseIdOnboardedPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/onboarded',
            ...options
        });
    }
}

export class PropertyPayments {
    /**
     * Get Available Bundles
     *
     * Get all available property bundles for purchase.
     */
    public static getAvailableBundlesPropertyBundlesGet<ThrowOnError extends boolean = false>(options?: Options<GetAvailableBundlesPropertyBundlesGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAvailableBundlesPropertyBundlesGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/property-bundles',
            ...options
        });
    }
    
    /**
     * Get Bundle
     *
     * Get a single property bundle by ID, including live price fetched from Stripe.
     *
     * Used by the frontend to display the price in the payment confirmation modal
     * without hardcoding amounts. The price is fetched live from Stripe so it
     * stays in sync with any pricing changes.
     */
    public static getBundlePropertyBundlesBundleIdGet<ThrowOnError extends boolean = false>(options: Options<GetBundlePropertyBundlesBundleIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetBundlePropertyBundlesBundleIdGetResponses, GetBundlePropertyBundlesBundleIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/property-bundles/{bundle_id}',
            ...options
        });
    }
    
    /**
     * Get Credit Balance
     *
     * Get current user's property credit balance.
     */
    public static getCreditBalanceCreditsBalanceGet<ThrowOnError extends boolean = false>(options?: Options<GetCreditBalanceCreditsBalanceGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetCreditBalanceCreditsBalanceGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/credits/balance',
            ...options
        });
    }
    
    /**
     * Create Credit Checkout
     *
     * Create a Stripe checkout session for purchasing property credits.
     */
    public static createCreditCheckoutCreditsCheckoutPost<ThrowOnError extends boolean = false>(options: Options<CreateCreditCheckoutCreditsCheckoutPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCreditCheckoutCreditsCheckoutPostResponses, CreateCreditCheckoutCreditsCheckoutPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/credits/checkout',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Verify Credit Purchase
     *
     * Verify a completed credit purchase and add credits to user's balance.
     */
    public static verifyCreditPurchaseCreditsVerifyPurchasePost<ThrowOnError extends boolean = false>(options: Options<VerifyCreditPurchaseCreditsVerifyPurchasePostData, ThrowOnError>) {
        return (options.client ?? client).post<VerifyCreditPurchaseCreditsVerifyPurchasePostResponses, VerifyCreditPurchaseCreditsVerifyPurchasePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/credits/verify-purchase',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Property Bundle
     *
     * Create a new property bundle (admin only).
     */
    public static createPropertyBundleAdminPropertyBundlesPost<ThrowOnError extends boolean = false>(options: Options<CreatePropertyBundleAdminPropertyBundlesPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreatePropertyBundleAdminPropertyBundlesPostResponses, CreatePropertyBundleAdminPropertyBundlesPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/admin/property-bundles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get User Credits Admin
     *
     * Get any user's credit balance (admin only).
     */
    public static getUserCreditsAdminAdminUsersUserIdCreditsGet<ThrowOnError extends boolean = false>(options: Options<GetUserCreditsAdminAdminUsersUserIdCreditsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetUserCreditsAdminAdminUsersUserIdCreditsGetResponses, GetUserCreditsAdminAdminUsersUserIdCreditsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/admin/users/{user_id}/credits',
            ...options
        });
    }
}

export class PropertyOwnership {
    /**
     * Get Property Ownership History
     *
     * Get the complete ownership history for a property.
     *
     * Returns all ownership transfers in chronological order with details
     * about previous owners, new owners, transfer reasons, and timestamps.
     *
     * Args:
     * house_id: ID of the property
     *
     * Returns:
     * List of ownership history records
     */
    public static getPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGet<ThrowOnError extends boolean = false>(options: Options<GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetResponses, GetPropertyOwnershipHistoryHousesHouseIdOwnershipHistoryGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/ownership-history',
            ...options
        });
    }
    
    /**
     * Cancel Pending Property Transfer
     *
     * Cancel a pending property transfer.
     *
     * Only the user who created the transfer or an admin can cancel it.
     *
     * Args:
     * house_id: ID of the property
     *
     * Returns:
     * Success message
     */
    public static cancelPendingPropertyTransferHousesHouseIdPendingTransferDelete<ThrowOnError extends boolean = false>(options: Options<CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteResponses, CancelPendingPropertyTransferHousesHouseIdPendingTransferDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/pending-transfer',
            ...options
        });
    }
    
    /**
     * Get Pending Property Transfer
     *
     * Get the current pending transfer for a property.
     *
     * Returns details about any active transfer invitation for the property.
     *
     * Args:
     * house_id: ID of the property
     *
     * Returns:
     * PendingTransferStatusResponse: Current pending transfer details
     */
    public static getPendingPropertyTransferHousesHouseIdPendingTransferGet<ThrowOnError extends boolean = false>(options: Options<GetPendingPropertyTransferHousesHouseIdPendingTransferGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetPendingPropertyTransferHousesHouseIdPendingTransferGetResponses, GetPendingPropertyTransferHousesHouseIdPendingTransferGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/pending-transfer',
            ...options
        });
    }
    
    /**
     * Create Pending Property Transfer
     *
     * Create a pending property transfer for a future user who doesn't exist yet.
     *
     * The system generates a secure token and sends an invitation email.
     * Only one pending transfer per property is allowed.
     *
     * Args:
     * house_id: ID of the property to transfer
     * transfer_request: Transfer details including recipient email
     *
     * Returns:
     * PendingPropertyTransferResponse: Transfer invitation details with secure token
     */
    public static createPendingPropertyTransferHousesHouseIdPendingTransferPost<ThrowOnError extends boolean = false>(options: Options<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreatePendingPropertyTransferHousesHouseIdPendingTransferPostResponses, CreatePendingPropertyTransferHousesHouseIdPendingTransferPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/pending-transfer',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Claim Pending Property Transfer
     *
     * Claim a pending property transfer using an invitation token.
     *
     * Ownership of the property moves to the claiming user. For a professional-to-owner
     * transfer the professional's archive is copied by a background task; an owner-to-owner
     * transfer completes synchronously.
     *
     * Args:
     * claim_request: Contains transfer token and user email for validation
     *
     * Returns:
     * PropertyOwnershipTransferResponse: Completed transfer details
     */
    public static claimPendingPropertyTransferClaimPropertyTransferPost<ThrowOnError extends boolean = false>(options: Options<ClaimPendingPropertyTransferClaimPropertyTransferPostData, ThrowOnError>) {
        return (options.client ?? client).post<ClaimPendingPropertyTransferClaimPropertyTransferPostResponses, ClaimPendingPropertyTransferClaimPropertyTransferPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/claim-property-transfer',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Pending Transfer Details
     *
     * Get pending transfer details by token (for signup page).
     *
     * This endpoint is public (no auth required) so the signup page can
     * display property details before user creates account.
     *
     * Args:
     * transfer_token: The secure invitation token
     *
     * Returns:
     * Basic transfer and property details for display
     */
    public static getPendingTransferDetailsPendingTransferTransferTokenGet<ThrowOnError extends boolean = false>(options: Options<GetPendingTransferDetailsPendingTransferTransferTokenGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetPendingTransferDetailsPendingTransferTransferTokenGetResponses, GetPendingTransferDetailsPendingTransferTransferTokenGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/pending-transfer/{transfer_token}',
            ...options
        });
    }
    
    /**
     * Retry Transfer Finalization
     *
     * Retry finalization of a failed property transfer.
     *
     * This endpoint allows retrying the async document/task cloning
     * via Celery if the background job failed.
     *
     * Args:
     * transfer_id: ID of the pending transfer
     *
     * Returns:
     * TransferRetryResponse with cloned house ID and status
     */
    public static retryTransferFinalizationPendingTransferTransferIdRetryPost<ThrowOnError extends boolean = false>(options: Options<RetryTransferFinalizationPendingTransferTransferIdRetryPostData, ThrowOnError>) {
        return (options.client ?? client).post<RetryTransferFinalizationPendingTransferTransferIdRetryPostResponses, RetryTransferFinalizationPendingTransferTransferIdRetryPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/pending-transfer/{transfer_id}/retry',
            ...options
        });
    }
}

export class Sharing {
    /**
     * List users this property is shared with
     */
    public static getHouseSharingHousesHouseIdSharingGet<ThrowOnError extends boolean = false>(options: Options<GetHouseSharingHousesHouseIdSharingGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHouseSharingHousesHouseIdSharingGetResponses, GetHouseSharingHousesHouseIdSharingGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/sharing',
            ...options
        });
    }
    
    /**
     * Add a user to this property's sharing list
     */
    public static addUserToSharingHousesHouseIdSharingUsersPost<ThrowOnError extends boolean = false>(options: Options<AddUserToSharingHousesHouseIdSharingUsersPostData, ThrowOnError>) {
        return (options.client ?? client).post<AddUserToSharingHousesHouseIdSharingUsersPostResponses, AddUserToSharingHousesHouseIdSharingUsersPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/sharing/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Send an invitation email to an added user
     */
    public static inviteSharingUserHousesHouseIdSharingUsersUserIdInvitePost<ThrowOnError extends boolean = false>(options: Options<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostData, ThrowOnError>) {
        return (options.client ?? client).post<InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostResponses, InviteSharingUserHousesHouseIdSharingUsersUserIdInvitePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/sharing/users/{user_id}/invite',
            ...options
        });
    }
    
    /**
     * Revoke a user's access (the row is kept in the sharing list as revoked)
     */
    public static removeSharingUserHousesHouseIdSharingUsersUserIdDelete<ThrowOnError extends boolean = false>(options: Options<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteResponses, RemoveSharingUserHousesHouseIdSharingUsersUserIdDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/sharing/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Update a shared user's role
     */
    public static updateSharingUserRoleHousesHouseIdSharingUsersUserIdPatch<ThrowOnError extends boolean = false>(options: Options<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchResponses, UpdateSharingUserRoleHousesHouseIdSharingUsersUserIdPatchErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/sharing/users/{user_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update a shared user's access expiry date
     */
    public static updateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatch<ThrowOnError extends boolean = false>(options: Options<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchResponses, UpdateSharingUserExpiryHousesHouseIdSharingUsersUserIdExpiryPatchErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/sharing/users/{user_id}/expiry',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Accept a sharing invitation for this property
     */
    public static acceptSharingInvitationHousesHouseIdSharingAcceptPost<ThrowOnError extends boolean = false>(options: Options<AcceptSharingInvitationHousesHouseIdSharingAcceptPostData, ThrowOnError>) {
        return (options.client ?? client).post<AcceptSharingInvitationHousesHouseIdSharingAcceptPostResponses, AcceptSharingInvitationHousesHouseIdSharingAcceptPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/sharing/accept',
            ...options
        });
    }
    
    /**
     * Access-activity timeline for a shared user
     *
     * The access-activity timeline (oldest first) for one user on a property: requests,
     * approvals, invites, expiry and role changes, removals and expiries. Scoped to the current
     * owner's tenure — a previous owner's events stay in the log but are not shown — and to the
     * product-visible events (audit-only events like `login` are excluded; see TIMELINE_EVENTS).
     */
    public static getSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGet<ThrowOnError extends boolean = false>(options: Options<GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetResponses, GetSharingUserActivityHousesHouseIdSharingUsersUserIdActivityGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/sharing/users/{user_id}/activity',
            ...options
        });
    }
}

export class Documents {
    /**
     * Upload Documents V2
     *
     * Upload one or more documents and trigger the v2 ingestion DAG (bnd_v2 → metadata_profiling → metadata_extraction → kbs).
     *
     * Two shapes, one endpoint:
     *
     * - **Single file** (legacy ``file`` part, no ``files``/``bundle_spec``) — unchanged contract:
     * creates one document (or a text-only note when ``file`` is omitted) and returns it in
     * ``document``.
     * - **Multi-file / bundle** (a ``files`` list and/or a ``bundle_spec`` JSON part) — creates each
     * file's document resiliently (one bad or already-present file does not sink the others) and,
     * when ``bundle_spec`` is present, groups the created documents into a ``DocumentBundle``. The
     * created documents come back in ``documents``, the group in ``bundle_id``, and anything
     * skipped/failed in ``skipped_filenames`` / ``failed_filenames``.
     *
     * Files are stored in GCS and each kicks off bnd_v2 via Celery; downstream pipelines
     * (metadata_profiling, metadata_extraction, kbs) advance automatically via document-level
     * reconciliation once each stage completes.
     */
    public static uploadDocumentsV2V2HousesHouseIdDocumentsPost<ThrowOnError extends boolean = false>(options: Options<UploadDocumentsV2V2HousesHouseIdDocumentsPostData, ThrowOnError>) {
        return (options.client ?? client).post<UploadDocumentsV2V2HousesHouseIdDocumentsPostResponses, UploadDocumentsV2V2HousesHouseIdDocumentsPostErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/documents',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Document V2
     *
     * Soft delete a v2 document.
     *
     * Marks the document as deleted synchronously, then triggers a background
     * task that tombstones metadata (property-level provenance/facts) and
     * removes the document from the Vertex AI KBS index.
     */
    public static deleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDelete<ThrowOnError extends boolean = false>(options: Options<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteResponses, DeleteDocumentV2V2HousesHouseIdDocumentsDocumentIdDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/documents/{document_id}',
            ...options
        });
    }
    
    /**
     * Get Document
     *
     * Get a single document with its presigned download URL, tags, and current summary.
     *
     * Use this endpoint to load document detail on demand from the UI instead of
     * fetching the full house document list.
     */
    public static getDocumentHousesHouseIdDocumentsDocumentIdGet<ThrowOnError extends boolean = false>(options: Options<GetDocumentHousesHouseIdDocumentsDocumentIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetDocumentHousesHouseIdDocumentsDocumentIdGetResponses, GetDocumentHousesHouseIdDocumentsDocumentIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/{document_id}',
            ...options
        });
    }
    
    /**
     * Update Document
     *
     * Update document by deleting old version and creating new one.
     *
     * V3 Architecture (Delete + Re-upload):
     * - Soft-deletes the old document (sets is_deleted=True)
     * - Creates a new document with previous_document_id reference
     * - Returns both old and new document IDs
     * - Triggers background task to upload and process new document
     */
    public static updateDocumentHousesHouseIdDocumentsDocumentIdPut<ThrowOnError extends boolean = false>(options: Options<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdateDocumentHousesHouseIdDocumentsDocumentIdPutResponses, UpdateDocumentHousesHouseIdDocumentsDocumentIdPutErrors, ThrowOnError>({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/{document_id}',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * List Documents
     *
     * Get documents with presigned download URLs.
     *
     * This endpoint provides documents with presigned download URLs by default,
     * eliminating the N+1 query problem by:
     * 1. Fetching all documents in one database query
     * 2. Generating all presigned URLs in one S3 session
     *
     * Performance: ~200-500ms vs 2-3 seconds for equivalent individual calls
     */
    public static listDocumentsHousesHouseIdDocumentsGet<ThrowOnError extends boolean = false>(options: Options<ListDocumentsHousesHouseIdDocumentsGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListDocumentsHousesHouseIdDocumentsGetResponses, ListDocumentsHousesHouseIdDocumentsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents',
            ...options
        });
    }
    
    /**
     * List House Corrections
     *
     * Everything the owner has corrected about this property, newest first.
     *
     * The document list carries each document's own corrections, so this exists for the ones it
     * cannot: a property fact amends no document, and appears nowhere else.
     *
     * Active corrections only. Removal is a soft deactivate and the rows are kept for the audit
     * trail; showing them would present a correction that no longer applies as if it still did.
     */
    public static listHouseCorrectionsHousesHouseIdCorrectionsGet<ThrowOnError extends boolean = false>(options: Options<ListHouseCorrectionsHousesHouseIdCorrectionsGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListHouseCorrectionsHousesHouseIdCorrectionsGetResponses, ListHouseCorrectionsHousesHouseIdCorrectionsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/corrections',
            ...options
        });
    }
    
    /**
     * Get Key Document Tags
     */
    public static getKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGet<ThrowOnError extends boolean = false>(options: Options<GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetResponses, GetKeyDocumentTagsHousesHouseIdDocumentsKeyDocTagsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/key-doc-tags',
            ...options
        });
    }
    
    /**
     * Get House Critical Info
     */
    public static getHouseCriticalInfoHousesHouseIdCriticalInfoGet<ThrowOnError extends boolean = false>(options: Options<GetHouseCriticalInfoHousesHouseIdCriticalInfoGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHouseCriticalInfoHousesHouseIdCriticalInfoGetResponses, GetHouseCriticalInfoHousesHouseIdCriticalInfoGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/critical-info',
            ...options
        });
    }
    
    /**
     * Update House Critical Info
     *
     * Update critical info using versioned delete-and-create pattern.
     *
     * This follows the same pattern as update_document by reusing the
     * replace_document_with_new_version service function.
     */
    public static updateHouseCriticalInfoHousesHouseIdCriticalInfoPut<ThrowOnError extends boolean = false>(options: Options<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutResponses, UpdateHouseCriticalInfoHousesHouseIdCriticalInfoPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/critical-info',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add Tag To Document
     *
     * Add a tag to a document.
     */
    public static addTagToDocumentHousesHouseIdDocumentsTagsPost<ThrowOnError extends boolean = false>(options: Options<AddTagToDocumentHousesHouseIdDocumentsTagsPostData, ThrowOnError>) {
        return (options.client ?? client).post<AddTagToDocumentHousesHouseIdDocumentsTagsPostResponses, AddTagToDocumentHousesHouseIdDocumentsTagsPostErrors, ThrowOnError>({
            responseType: 'text',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/tags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Replace Tag In Document
     *
     * Replace a tag in a document.
     */
    public static replaceTagInDocumentHousesHouseIdDocumentsTagsPut<ThrowOnError extends boolean = false>(options: Options<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutData, ThrowOnError>) {
        return (options.client ?? client).put<ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutResponses, ReplaceTagInDocumentHousesHouseIdDocumentsTagsPutErrors, ThrowOnError>({
            responseType: 'text',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/tags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove Tag From Document
     *
     * Remove a tag from a document.
     */
    public static removeTagFromDocumentDocumentsTagsDelete<ThrowOnError extends boolean = false>(options: Options<RemoveTagFromDocumentDocumentsTagsDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RemoveTagFromDocumentDocumentsTagsDeleteResponses, RemoveTagFromDocumentDocumentsTagsDeleteErrors, ThrowOnError>({
            responseType: 'text',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/documents/tags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Classification Tags
     *
     * Retrieve all classification tags for document categorization.
     *
     * These tags are surfaced to users for organizing documents into categories
     * like "Property & Site", "Services", "Plans & Drawings", etc.
     *
     * Parameters:
     * - active_only (bool): If True, only return active tags. Default: True
     *
     * Returns:
     * - List[Tag]: List of classification tags ordered by name
     */
    public static getClassificationTagsTagsClassificationsGet<ThrowOnError extends boolean = false>(options?: Options<GetClassificationTagsTagsClassificationsGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetClassificationTagsTagsClassificationsGetResponses, GetClassificationTagsTagsClassificationsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/tags/classifications',
            ...options
        });
    }
    
    /**
     * Get Batch Download Urls
     *
     * Get presigned download URLs for specific documents in a single request.
     *
     * This eliminates the N+1 query problem for selective document downloads.
     * Use this when you only need URLs for specific documents.
     */
    public static getBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPost<ThrowOnError extends boolean = false>(options: Options<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostData, ThrowOnError>) {
        return (options.client ?? client).post<GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostResponses, GetBatchDownloadUrlsHousesHouseIdDocumentsBatchDownloadUrlsPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/batch-download-urls',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Download Document Optimized
     *
     * Get presigned download URL for a single document.
     * Now uses the optimized batch function internally for consistency.
     */
    public static downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGet<ThrowOnError extends boolean = false>(options: Options<DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetData, ThrowOnError>) {
        return (options.client ?? client).get<DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetResponses, DownloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/{document_id}/download',
            ...options
        });
    }
    
    /**
     * Update document visibility (private/public)
     */
    public static updateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatch<ThrowOnError extends boolean = false>(options: Options<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchResponses, UpdateDocumentVisibilityHousesHouseIdDocumentsDocumentIdVisibilityPatchErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/{document_id}/visibility',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Share Documents With Owner Endpoint
     *
     * Share/Sync multiple documents with the property owner.
     *
     * Executes synchronously: creates PendingDocumentShare records and dispatches
     * document.shared events for notifications. No background tasks are scheduled.
     *
     * - Authorization: Requires HOUSE_DOCUMENT_SHARE_PROPOSED permission for the house (Owner only).
     * - The user must have access to all documents being shared.
     * - Accepts a list of document_ids and an optional message in the body.
     * - Returns a list of created pending shares.
     */
    public static shareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePost<ThrowOnError extends boolean = false>(options: Options<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostData, ThrowOnError>) {
        return (options.client ?? client).post<ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostResponses, ShareDocumentsWithOwnerEndpointHousesHouseIdDocumentsSharePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/share',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get House Pipeline Status V2
     *
     * Get aggregate pipeline status for all documents in a house — V2 pipelines.
     *
     * Returns counts for bnd_v2, metadata, kbs, and document_enrichment pipelines
     * across all non-deleted documents. A house is fully complete when all documents
     * have kbs == COMPLETED (terminal node of the V2 DAG).
     *
     * Never returns arrays — always a single aggregate object with counts.
     */
    public static getHousePipelineStatusV2HousesHouseIdPipelineV2StatusGet<ThrowOnError extends boolean = false>(options: Options<GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetResponses, GetHousePipelineStatusV2HousesHouseIdPipelineV2StatusGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/pipeline/v2/status',
            ...options
        });
    }
    
    /**
     * Get House Documents Status
     *
     * [DEPRECATED] Get pipeline status for all documents in a house — V1 pipelines only.
     *
     * Returns an array with one entry per non-deleted document, including pipeline
     * status for bnd and kb_sync. Use /houses/{house_id}/documents/v2/status for V2 pipelines.
     *
     * Excludes soft-deleted documents.
     *
     * Supports HTTP caching via Last-Modified/If-Modified-Since headers.
     *
     * @deprecated
     */
    public static getHouseDocumentsStatusHousesHouseIdDocumentsStatusGet<ThrowOnError extends boolean = false>(options: Options<GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetResponses, GetHouseDocumentsStatusHousesHouseIdDocumentsStatusGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/status',
            ...options
        });
    }
    
    /**
     * Get House Documents Status V2
     *
     * Get pipeline status for all documents in a house — V2 pipelines.
     *
     * Returns an array with one entry per non-deleted document, including pipeline
     * status for bnd_v2, metadata, kbs, and document_enrichment.
     *
     * Excludes soft-deleted documents.
     *
     * Supports HTTP caching via Last-Modified/If-Modified-Since headers.
     */
    public static getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGet<ThrowOnError extends boolean = false>(options: Options<GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetResponses, GetHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/v2/status',
            ...options
        });
    }
    
    /**
     * Finalize House Setup
     *
     * Finalize house setup after all initial documents are uploaded.
     *
     * This endpoint:
     * 1. Sets house.onboarded = True flag (synchronously)
     * 2. Triggers email delivery (asynchronously via Celery)
     *
     * Maintenance schedule generation is triggered separately.
     *
     * Should be called by UI when user completes document upload step.
     *
     * Returns:
     * 200 OK with success message
     */
    public static finalizeHouseSetupHousesHouseIdFinalizePost<ThrowOnError extends boolean = false>(options: Options<FinalizeHouseSetupHousesHouseIdFinalizePostData, ThrowOnError>) {
        return (options.client ?? client).post<FinalizeHouseSetupHousesHouseIdFinalizePostResponses, FinalizeHouseSetupHousesHouseIdFinalizePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/finalize',
            ...options
        });
    }
    
    /**
     * List Received Pending Shares
     *
     * List pending document shares targeting this house (house needs to accept).
     * Includes presigned download URLs for document preview.
     */
    public static listReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGet<ThrowOnError extends boolean = false>(options: Options<ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetResponses, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/pending/received',
            ...options
        });
    }
    
    /**
     * List Sent Pending Shares
     *
     * List pending document shares originating from this house (shared from documents of this house).
     */
    public static listSentPendingSharesHousesHouseIdDocumentsPendingSentGet<ThrowOnError extends boolean = false>(options: Options<ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetResponses, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/pending/sent',
            ...options
        });
    }
    
    /**
     * Get Pending Share
     *
     * Get a specific pending document share by ID.
     */
    public static getPendingShareHousesHouseIdDocumentsPendingShareIdGet<ThrowOnError extends boolean = false>(options: Options<GetPendingShareHousesHouseIdDocumentsPendingShareIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetPendingShareHousesHouseIdDocumentsPendingShareIdGetResponses, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/pending/{share_id}',
            ...options
        });
    }
    
    /**
     * Update Pending Share Status
     *
     * Accept or reject a pending document share.
     *
     * Only the share recipient (shared_to_user) can perform this action.
     * Updates the share status and marks the related notification as acted upon.
     *
     * Request body:
     * - status: "accepted" or "rejected"
     * - resolution_note: Optional note explaining rejection
     *
     * Returns:
     * - 200 with updated PendingDocumentShareResponse on success
     * - 400 if share is not pending or invalid status
     * - 403 if user is not the share recipient
     * - 404 if share not found
     */
    public static updatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPut<ThrowOnError extends boolean = false>(options: Options<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutResponses, UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/pending/{share_id}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PendingShares {
    /**
     * List Received Pending Shares
     *
     * List pending document shares targeting this house (house needs to accept).
     * Includes presigned download URLs for document preview.
     */
    public static listReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGet<ThrowOnError extends boolean = false>(options: Options<ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetResponses, ListReceivedPendingSharesHousesHouseIdDocumentsPendingReceivedGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/pending/received',
            ...options
        });
    }
    
    /**
     * List Sent Pending Shares
     *
     * List pending document shares originating from this house (shared from documents of this house).
     */
    public static listSentPendingSharesHousesHouseIdDocumentsPendingSentGet<ThrowOnError extends boolean = false>(options: Options<ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetResponses, ListSentPendingSharesHousesHouseIdDocumentsPendingSentGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/pending/sent',
            ...options
        });
    }
    
    /**
     * Get Pending Share
     *
     * Get a specific pending document share by ID.
     */
    public static getPendingShareHousesHouseIdDocumentsPendingShareIdGet<ThrowOnError extends boolean = false>(options: Options<GetPendingShareHousesHouseIdDocumentsPendingShareIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetPendingShareHousesHouseIdDocumentsPendingShareIdGetResponses, GetPendingShareHousesHouseIdDocumentsPendingShareIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/pending/{share_id}',
            ...options
        });
    }
    
    /**
     * Update Pending Share Status
     *
     * Accept or reject a pending document share.
     *
     * Only the share recipient (shared_to_user) can perform this action.
     * Updates the share status and marks the related notification as acted upon.
     *
     * Request body:
     * - status: "accepted" or "rejected"
     * - resolution_note: Optional note explaining rejection
     *
     * Returns:
     * - 200 with updated PendingDocumentShareResponse on success
     * - 400 if share is not pending or invalid status
     * - 403 if user is not the share recipient
     * - 404 if share not found
     */
    public static updatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPut<ThrowOnError extends boolean = false>(options: Options<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutResponses, UpdatePendingShareStatusHousesHouseIdDocumentsPendingShareIdStatusPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/documents/pending/{share_id}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Notifications {
    /**
     * Get Notifications
     *
     * Get notifications for the current user scoped to a specific house.
     *
     * Query parameters:
     * - status: Filter by status (pending, sent, read, acted_upon, expired)
     * - type: Filter by type (document_share_request, etc.)
     * - limit: Maximum number of notifications to return (default 50)
     */
    public static getNotificationsHousesHouseIdNotificationsGet<ThrowOnError extends boolean = false>(options: Options<GetNotificationsHousesHouseIdNotificationsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetNotificationsHousesHouseIdNotificationsGetResponses, GetNotificationsHousesHouseIdNotificationsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/notifications',
            ...options
        });
    }
    
    /**
     * Mark Notification As Read
     *
     * Mark a notification as read.
     */
    public static markNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPost<ThrowOnError extends boolean = false>(options: Options<MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostData, ThrowOnError>) {
        return (options.client ?? client).post<MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostResponses, MarkNotificationAsReadHousesHouseIdNotificationsNotificationIdReadPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/notifications/{notification_id}/read',
            ...options
        });
    }
    
    /**
     * Get Notification
     *
     * Get a specific notification by ID scoped to a house.
     */
    public static getNotificationHousesHouseIdNotificationsNotificationIdGet<ThrowOnError extends boolean = false>(options: Options<GetNotificationHousesHouseIdNotificationsNotificationIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetNotificationHousesHouseIdNotificationsNotificationIdGetResponses, GetNotificationHousesHouseIdNotificationsNotificationIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/notifications/{notification_id}',
            ...options
        });
    }
}

export class MaintenanceV2 {
    /**
     * Post Plan Action
     *
     * Apply one plan action on a card the homeowner acts on by echoing its opaque ``resolve_token``.
     *
     * ONE endpoint, two transports (content-negotiated): a JSON body for a file-less action
     * (dismiss/keep/complete/snooze/skip/clear/note/reschedule/edit/…), or
     * ``multipart/form-data`` when the action carries a comment and/or file attachments — the latter
     * become a ``maintenance_resolution`` bundle anchored to the occurrence, mirrored onto the plan
     * card (comment + attachment references). Both flow through the same evidence core.
     *
     * The token decodes to the durable obligation anchor; the decision (and any bundle + members +
     * occasion anchor + write-through mirrors) is appended + projected in ONE transaction — the atomic
     * acceptance boundary — after which attachment ingestion is scheduled async and the plan cache is
     * asked to reconcile. A token this server did not mint is a 422, never a guess at an anchor.
     * Idempotent on an optional ``client_token``: a retry with the same token replays the stored
     * response without re-executing (so a double-submit never creates a duplicate bundle), and a token
     * reused for a different request is a 409. Custom-entry create has its own endpoint (it mints the
     * anchor).
     */
    public static postPlanActionV2HousesHouseIdMaintenanceActionsPost<ThrowOnError extends boolean = false>(options: Options<PostPlanActionV2HousesHouseIdMaintenanceActionsPostData, ThrowOnError>) {
        return (options.client ?? client).post<PostPlanActionV2HousesHouseIdMaintenanceActionsPostResponses, PostPlanActionV2HousesHouseIdMaintenanceActionsPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/maintenance/actions',
            ...options
        });
    }
    
    /**
     * Get Maintenance Plan
     *
     * The property's unified maintenance plan — the read model the homeowner UI consumes.
     *
     * Read-only. Thin wrapper over ``get_property_maintenance_plan`` (the SAME function the local
     * plan-viewer QA tool renders, with ``emit_plan_nodes=True``), served through the durable
     * per-property view-cache: the unfiltered core is computed once and cached, and
     * filter/sort/paginate + the PlanNode projection run cheaply on egress. Facets are computed over
     * the UNFILTERED set (so the UI can show counts for unselected filters); grouping happens before
     * pagination, so a grouped card counts as one item and its children travel with it. The cache is
     * always-on and fail-open, so a read never fails on a cache error — it degrades to a live compute.
     *
     * Calendar view: pass ``occurrences_from`` + ``occurrences_to`` to have each recurring card carry
     * its dated ``occurrences[]`` in that window (materialized instances, not rule re-expansion), so
     * the FE can render a calendar that shows recurrence across years. Occurrences beyond the
     * materialized horizon are not returned — see the horizon note in the service. ``occurrence_status``
     * then filters those nested occurrences by their OWN state (``completed,skipped,snoozed`` for a
     * History view that skips the untouched upcoming dates) — it narrows the nested list, never the
     * cards, so a card with no matching date simply carries an empty ``occurrences[]``.
     */
    public static getMaintenancePlanV2HousesHouseIdMaintenancePlanGet<ThrowOnError extends boolean = false>(options: Options<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetResponses, GetMaintenancePlanV2HousesHouseIdMaintenancePlanGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/maintenance/plan',
            ...options
        });
    }
    
    /**
     * Get Card Timeline
     *
     * What has happened to one card — every verdict, edit, deferral and completion, newest first.
     *
     * Read-only, and deliberately separate from the plan: the plan says what is true of a card now,
     * this says what the household decided and when. Rows are folded into the actions that produced
     * them, so a completion carrying a comment and a photo reads as one entry rather than three (see
     * `TimelineActionOut`). Decisions recorded before actions were correlated are reported as actions
     * of one rather than guessed into groups.
     */
    public static getCardTimelineV2HousesHouseIdMaintenanceTimelineGet<ThrowOnError extends boolean = false>(options: Options<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetResponses, GetCardTimelineV2HousesHouseIdMaintenanceTimelineGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/maintenance/timeline',
            ...options
        });
    }
    
    /**
     * Get Discarded Cards
     *
     * The cards the homeowner has discarded — History's restore list.
     *
     * Read-only, and deliberately separate from the plan read: the active plan, its cache and its
     * counts are untouched, so opening this can never move a plan number. Every card comes back as a
     * normal PlanNode carrying `review.status = "removed"` and `restore` in `allowed_actions` (pruned to
     * what THIS reader may do), so it renders with the same components as any other card and is put back
     * through the same action endpoint — echo the card's `resolve_token` with `action="restore"`.
     */
    public static getDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGet<ThrowOnError extends boolean = false>(options: Options<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetResponses, GetDiscardedCardsV2HousesHouseIdMaintenanceDiscardedGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/maintenance/discarded',
            ...options
        });
    }
    
    /**
     * Create Custom Entry
     *
     * Add a task of the homeowner's own to this property's plan.
     *
     * Returns the stored entry, NOT a plan card. The entry's FIRST occurrence is materialised in this
     * same transaction, so the card is actionable on the very next plan read (re-read the plan to get
     * it); the async reconcile then fills in the rest of a recurring series' horizon. Re-read rather
     * than constructing the card from this response.
     *
     * Create is the only endpoint these entries need. The resulting card carries a ``resolve_token``
     * like any other, so completing, snoozing or annotating it goes through the ordinary
     * occurrence-resolve path.
     */
    public static createCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPost<ThrowOnError extends boolean = false>(options: Options<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostResponses, CreateCustomEntryV2HousesHouseIdMaintenanceCustomEntriesPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/v2/houses/{house_id}/maintenance/custom-entries',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Authentication {
    /**
     * Google Login
     */
    public static googleLoginGoogleTokenPost<ThrowOnError extends boolean = false>(options: Options<GoogleLoginGoogleTokenPostData, ThrowOnError>) {
        return (options.client ?? client).post<GoogleLoginGoogleTokenPostResponses, GoogleLoginGoogleTokenPostErrors, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            responseType: 'json',
            url: '/google-token',
            ...options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options.headers
            }
        });
    }
    
    /**
     * Login For Access Token
     *
     * Login for access token using DRY factory functions
     */
    public static loginForAccessTokenTokenPost<ThrowOnError extends boolean = false>(options: Options<LoginForAccessTokenTokenPostData, ThrowOnError>) {
        return (options.client ?? client).post<LoginForAccessTokenTokenPostResponses, LoginForAccessTokenTokenPostErrors, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            responseType: 'json',
            url: '/token',
            ...options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options.headers
            }
        });
    }
    
    /**
     * Refresh Access Token
     *
     * Refresh access token using DRY factory functions
     */
    public static refreshAccessTokenTokenRefreshPost<ThrowOnError extends boolean = false>(options: Options<RefreshAccessTokenTokenRefreshPostData, ThrowOnError>) {
        return (options.client ?? client).post<RefreshAccessTokenTokenRefreshPostResponses, RefreshAccessTokenTokenRefreshPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/token/refresh',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Request Guest Access
     */
    public static requestGuestAccessHousesHouseIdAccessRequestPost<ThrowOnError extends boolean = false>(options: Options<RequestGuestAccessHousesHouseIdAccessRequestPostData, ThrowOnError>) {
        return (options.client ?? client).post<RequestGuestAccessHousesHouseIdAccessRequestPostResponses, RequestGuestAccessHousesHouseIdAccessRequestPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/houses/{house_id}/access-request',
            ...options
        });
    }
    
    /**
     * Get Guest Access Status
     */
    public static getGuestAccessStatusAccessStatusRequestIdGet<ThrowOnError extends boolean = false>(options: Options<GetGuestAccessStatusAccessStatusRequestIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetGuestAccessStatusAccessStatusRequestIdGetResponses, GetGuestAccessStatusAccessStatusRequestIdGetErrors, ThrowOnError>({
            responseType: 'json',
            url: '/access-status/{request_id}',
            ...options
        });
    }
}

export class Tasks {
    /**
     * Check Resource State
     *
     * Check the current state of a resource.
     *
     * Returns:
     * - A dictionary indicating the resource state.
     */
    public static checkResourceStateResourcesResourceIdStateGet<ThrowOnError extends boolean = false>(options: Options<CheckResourceStateResourcesResourceIdStateGetData, ThrowOnError>) {
        return (options.client ?? client).get<CheckResourceStateResourcesResourceIdStateGetResponses, CheckResourceStateResourcesResourceIdStateGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/resources/{resource_id}/state',
            ...options
        });
    }
    
    /**
     * Get Task Status Paginated
     *
     * Retrieve a paginated summary of tasks in the system.
     *
     * Query Parameters:
     * - limit: Number of tasks to retrieve.
     * - offset: Number of tasks to skip.
     *
     * Returns:
     * - A dictionary mapping task IDs to their status and progress.
     */
    public static getTaskStatusPaginatedTasksStatusGet<ThrowOnError extends boolean = false>(options?: Options<GetTaskStatusPaginatedTasksStatusGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetTaskStatusPaginatedTasksStatusGetResponses, GetTaskStatusPaginatedTasksStatusGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/tasks/status',
            ...options
        });
    }
    
    /**
     * Get Resource Tasks
     *
     * Endpoint to retrieve tasks associated with a resource.
     */
    public static getResourceTasksResourcesResourceIdTasksGet<ThrowOnError extends boolean = false>(options: Options<GetResourceTasksResourcesResourceIdTasksGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetResourceTasksResourcesResourceIdTasksGetResponses, GetResourceTasksResourcesResourceIdTasksGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/resources/{resource_id}/tasks',
            ...options
        });
    }
    
    /**
     * Check Task Completed
     *
     * Check if a task has been completed.
     *
     * Parameters:
     * - task_id (str): The ID of the task.
     *
     * Returns:
     * - A dictionary indicating the task status and progress.
     */
    public static checkTaskCompletedTasksTaskIdStatusGet<ThrowOnError extends boolean = false>(options: Options<CheckTaskCompletedTasksTaskIdStatusGetData, ThrowOnError>) {
        return (options.client ?? client).get<CheckTaskCompletedTasksTaskIdStatusGetResponses, CheckTaskCompletedTasksTaskIdStatusGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/tasks/{task_id}/status',
            ...options
        });
    }
    
    /**
     * Get House Tasks
     *
     * Retrieve all tasks associated with a specific house.
     *
     * Parameters:
     * - house_id (int): The ID of the house.
     *
     * Returns:
     * - A list of tasks associated with the house, including their status, progress, and metadata.
     */
    public static getHouseTasksHousesHouseIdTasksGet<ThrowOnError extends boolean = false>(options: Options<GetHouseTasksHousesHouseIdTasksGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHouseTasksHousesHouseIdTasksGetResponses, GetHouseTasksHousesHouseIdTasksGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/tasks',
            ...options
        });
    }
}

export class GoogleMaps {
    /**
     * Search Places
     *
     * Search for places using Google Places Autocomplete API.
     *
     * This endpoint provides autocomplete suggestions for location searches.
     * Requires authentication to prevent abuse and track usage.
     *
     * Args:
     * query: The search query string (1-100 characters)
     * country: Optional ISO 3166-1 alpha-2 country code to restrict results
     * types: Optional place types filter (address, establishment, etc.)
     * current_user: Authenticated user (injected by dependency)
     *
     * Returns:
     * AutocompleteResponse with list of place predictions
     *
     * Raises:
     * HTTPException: 400 for invalid requests, 503 for API service errors
     *
     * Example:
     * GET /maps/autocomplete?query=123%20Main%20St&country=us&types=address
     */
    public static searchPlacesMapsAutocompleteGet<ThrowOnError extends boolean = false>(options: Options<SearchPlacesMapsAutocompleteGetData, ThrowOnError>) {
        return (options.client ?? client).get<SearchPlacesMapsAutocompleteGetResponses, SearchPlacesMapsAutocompleteGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/maps/autocomplete',
            ...options
        });
    }
    
    /**
     * Get Place Info
     *
     * Get detailed information about a specific place.
     *
     * This endpoint retrieves comprehensive details about a place using its Google Places ID.
     * Requires authentication to prevent abuse and track usage.
     *
     * Args:
     * place_id: Google Places ID obtained from autocomplete results
     * fields: Comma-separated list of fields to return from the API
     * current_user: Authenticated user (injected by dependency)
     *
     * Returns:
     * PlaceDetailsResponse with detailed place information
     *
     * Raises:
     * HTTPException: 400 for invalid place_id, 503 for API service errors
     *
     * Example:
     * GET /maps/place/ChIJN1t_tDeuEmsRUsoyG83frY4?fields=name,formatted_address,geometry
     */
    public static getPlaceInfoMapsPlacePlaceIdGet<ThrowOnError extends boolean = false>(options: Options<GetPlaceInfoMapsPlacePlaceIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetPlaceInfoMapsPlacePlaceIdGetResponses, GetPlaceInfoMapsPlacePlaceIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/maps/place/{place_id}',
            ...options
        });
    }
}

export class GuestAccess {
    /**
     * Qr Landing Page
     *
     * QR code landing page endpoint.
     *
     * Accepts the property public ID (string) that is embedded in the QR code URL.
     * Generates a request ticket, sets it as an HttpOnly cookie, and returns
     * house information for the frontend to display the access request form.
     *
     * Rate limit: 5 per minute, 20 per hour per IP
     */
    public static qrLandingPageQrPropertyPublicIdGet<ThrowOnError extends boolean = false>(options: Options<QrLandingPageQrPropertyPublicIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<QrLandingPageQrPropertyPublicIdGetResponses, QrLandingPageQrPropertyPublicIdGetErrors, ThrowOnError>({
            responseType: 'json',
            url: '/qr/{property_public_id}',
            ...options
        });
    }
    
    /**
     * Submit Access Request
     *
     * Submit a guest access request.
     *
     * Validates the request ticket from cookie, creates a pending grant,
     * and sends notification emails to both owner and requester.
     *
     * Rate limit: 3 per hour per IP per house
     */
    public static submitAccessRequestHousesHouseIdGuestAccessRequestsPost<ThrowOnError extends boolean = false>(options: Options<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostData, ThrowOnError>) {
        return (options.client ?? client).post<SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostResponses, SubmitAccessRequestHousesHouseIdGuestAccessRequestsPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/houses/{house_id}/guest-access/requests',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Approve Access Grant
     *
     * Approve a guest access grant (authenticated owner).
     *
     * Validates owner permissions, approves the grant, generates a magic token,
     * and sends notification emails to both owner and requester.
     *
     * Rate limit: 10 per minute per user
     */
    public static approveAccessGrantGuestAccessGrantIdApprovePost<ThrowOnError extends boolean = false>(options: Options<ApproveAccessGrantGuestAccessGrantIdApprovePostData, ThrowOnError>) {
        return (options.client ?? client).post<ApproveAccessGrantGuestAccessGrantIdApprovePostResponses, ApproveAccessGrantGuestAccessGrantIdApprovePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/guest-access/{grant_id}/approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deny Access Grant
     *
     * Deny a guest access grant (authenticated owner).
     *
     * Validates owner permissions, denies the grant, and sends notification
     * email to the requester.
     *
     * Rate limit: 10 per minute per user
     */
    public static denyAccessGrantGuestAccessGrantIdDenyPost<ThrowOnError extends boolean = false>(options: Options<DenyAccessGrantGuestAccessGrantIdDenyPostData, ThrowOnError>) {
        return (options.client ?? client).post<DenyAccessGrantGuestAccessGrantIdDenyPostResponses, DenyAccessGrantGuestAccessGrantIdDenyPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/guest-access/{grant_id}/deny',
            ...options
        });
    }
    
    /**
     * Create Guest Invitation
     *
     * Create and approve a guest access invitation.
     *
     * Creates a grant directly in approved status, generates magic token,
     * and sends invitation email.
     * Combines request and approval in one step.
     *
     * TODO: The logic is very to the approval endpoint.
     * The code is duplicated as in the approval, but is kept this way for now as it might change in the future.
     */
    public static createGuestInvitationHousesHouseIdGuestAccessInvitePost<ThrowOnError extends boolean = false>(options: Options<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateGuestInvitationHousesHouseIdGuestAccessInvitePostResponses, CreateGuestInvitationHousesHouseIdGuestAccessInvitePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/guest-access/invite',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Verify Guest Code
     *
     * Verify the 6-digit code for guest access.
     */
    public static verifyGuestCodeGuestAccessMagicVerifyPost<ThrowOnError extends boolean = false>(options: Options<VerifyGuestCodeGuestAccessMagicVerifyPostData, ThrowOnError>) {
        return (options.client ?? client).post<VerifyGuestCodeGuestAccessMagicVerifyPostResponses, VerifyGuestCodeGuestAccessMagicVerifyPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/guest-access/magic/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Request Guest Code
     *
     * Request/Resend the 6-digit verification code to the guest's email.
     */
    public static requestGuestCodeGuestAccessMagicCodePost<ThrowOnError extends boolean = false>(options: Options<RequestGuestCodeGuestAccessMagicCodePostData, ThrowOnError>) {
        return (options.client ?? client).post<RequestGuestCodeGuestAccessMagicCodePostResponses, RequestGuestCodeGuestAccessMagicCodePostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/guest-access/magic/code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Redeem Magic Token
     *
     * Redeem a magic token for guest access.
     *
     * Validates the magic token, checks grant status, creates guest JWT,
     * and logs the login event.
     *
     * Rate limit: 20 per minute per token
     */
    public static redeemMagicTokenGuestAccessMagicRedeemPost<ThrowOnError extends boolean = false>(options: Options<RedeemMagicTokenGuestAccessMagicRedeemPostData, ThrowOnError>) {
        return (options.client ?? client).post<RedeemMagicTokenGuestAccessMagicRedeemPostResponses, RedeemMagicTokenGuestAccessMagicRedeemPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/guest-access/magic/redeem',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Manage Guest Access
     *
     * Extend, reduce, or revoke guest access for an active grant.
     *
     * This endpoint allows property owners to modify active guest access:
     * - extend: Set expires_at to a future date beyond current expiration
     * - reduce: Set expires_at to an earlier date
     * - revoke: Set expires_at to current time (immediate revocation)
     *
     * The endpoint handles both grant and house association synchronization.
     */
    public static manageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPut<ThrowOnError extends boolean = false>(options: Options<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutData, ThrowOnError>) {
        return (options.client ?? client).put<ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutResponses, ManageGuestAccessHousesHouseIdGuestAccessGrantIdAccessPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/guest-access/{grant_id}/access',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get House Grants
     *
     * Get all guest access grants for a property.
     *
     * Returns a list of all grants for the specified house. Only property owners
     * or users with guest access management permissions can access this endpoint.
     *
     * Query Parameters:
     * - active_only: Only return active (approved and not expired) grants
     * - status: Filter by grant status (pending, approved, denied, revoked, expired)
     */
    public static getHouseGrantsHousesHouseIdGuestAccessGrantsGet<ThrowOnError extends boolean = false>(options: Options<GetHouseGrantsHousesHouseIdGuestAccessGrantsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHouseGrantsHousesHouseIdGuestAccessGrantsGetResponses, GetHouseGrantsHousesHouseIdGuestAccessGrantsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/guest-access/grants',
            ...options
        });
    }
    
    /**
     * Approve Via Magic Token
     *
     * Approve a guest access grant using magic token from email.
     *
     * This endpoint allows property owners to approve grants directly from
     * email links without requiring full authentication. The magic token
     * provides temporary, scoped authorization for this specific action.
     */
    public static approveViaMagicTokenGuestAccessManageApproveViaTokenPost<ThrowOnError extends boolean = false>(options: Options<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostData, ThrowOnError>) {
        return (options.client ?? client).post<ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostResponses, ApproveViaMagicTokenGuestAccessManageApproveViaTokenPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/guest-access/manage/approve-via-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deny Via Magic Token
     *
     * Deny a guest access grant using magic token from email.
     */
    public static denyViaMagicTokenGuestAccessManageDenyViaTokenPost<ThrowOnError extends boolean = false>(options: Options<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostData, ThrowOnError>) {
        return (options.client ?? client).post<DenyViaMagicTokenGuestAccessManageDenyViaTokenPostResponses, DenyViaMagicTokenGuestAccessManageDenyViaTokenPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/guest-access/manage/deny-via-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Magic Token Info
     *
     * Return status info for a magic token.
     *
     * Unauthenticated callers receive status + property_address only.
     * Authenticated callers also receive email_matches and has_property_access booleans.
     * The raw invite email is never returned to prevent enumeration.
     */
    public static getMagicTokenInfoGuestAccessMagicInfoGet<ThrowOnError extends boolean = false>(options: Options<GetMagicTokenInfoGuestAccessMagicInfoGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetMagicTokenInfoGuestAccessMagicInfoGetResponses, GetMagicTokenInfoGuestAccessMagicInfoGetErrors, ThrowOnError>({
            responseType: 'json',
            url: '/guest-access/magic/info',
            ...options
        });
    }
    
    /**
     * Authenticated Qr Access Request
     *
     * Submit a QR code access request for an authenticated user.
     *
     * No email or identity verification needed — the system already knows who they are.
     * Creates a pending grant and notifies all house owners/admins.
     * Returns 409 if a pending or approved grant already exists for this user.
     */
    public static authenticatedQrAccessRequestHousesHouseIdQrAccessRequestPost<ThrowOnError extends boolean = false>(options: Options<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostData, ThrowOnError>) {
        return (options.client ?? client).post<AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostResponses, AuthenticatedQrAccessRequestHousesHouseIdQrAccessRequestPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/qr-access/request',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Grant Info
     *
     * Return grant info for the owner approval page.
     *
     * Called when the owner loads the magic-link approval page from their notification email.
     * Returns pending details or resolved state (for when a second admin arrives after the
     * first has already handled the request).
     */
    public static getGrantInfoGuestAccessManageInfoGet<ThrowOnError extends boolean = false>(options: Options<GetGrantInfoGuestAccessManageInfoGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetGrantInfoGuestAccessManageInfoGetResponses, GetGrantInfoGuestAccessManageInfoGetErrors, ThrowOnError>({
            responseType: 'json',
            url: '/guest-access/manage/info',
            ...options
        });
    }
}

export class Legal {
    /**
     * Get Current Legal Version
     *
     * Get current active legal version
     */
    public static getCurrentLegalVersionLegalCurrentVersionGet<ThrowOnError extends boolean = false>(options?: Options<GetCurrentLegalVersionLegalCurrentVersionGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetCurrentLegalVersionLegalCurrentVersionGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/legal/current-version',
            ...options
        });
    }
}

export class ProfessionalContacts {
    /**
     * List Service Categories
     *
     * List all service categories (core, suggested, and custom).
     *
     * Returns categories sorted alphabetically.
     */
    public static listServiceCategoriesServiceCategoriesGet<ThrowOnError extends boolean = false>(options?: Options<ListServiceCategoriesServiceCategoriesGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ListServiceCategoriesServiceCategoriesGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/service-categories',
            ...options
        });
    }
    
    /**
     * Create Custom Category
     *
     * Create a custom service category.
     *
     * Only property owners can create custom categories.
     * Category code must be unique.
     */
    public static createCustomCategoryServiceCategoriesPost<ThrowOnError extends boolean = false>(options: Options<CreateCustomCategoryServiceCategoriesPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCustomCategoryServiceCategoriesPostResponses, CreateCustomCategoryServiceCategoriesPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/service-categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Property Contacts
     *
     * List all contacts for a property, grouped by category.
     *
     * Returns summary with:
     * - Total contacts count
     * - Core categories filled count
     * - Trusted contacts count
     * - Contacts grouped by category
     */
    public static listPropertyContactsHousesHouseIdContactsGet<ThrowOnError extends boolean = false>(options: Options<ListPropertyContactsHousesHouseIdContactsGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListPropertyContactsHousesHouseIdContactsGetResponses, ListPropertyContactsHousesHouseIdContactsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts',
            ...options
        });
    }
    
    /**
     * Add Contact To Property
     *
     * Add a new contact to a property.
     *
     * This endpoint:
     * - Creates or finds the professional contact
     * - Creates an organization if needed
     * - Creates the property contact association
     * - Handles deduplication by email/phone
     */
    public static addContactToPropertyHousesHouseIdContactsPost<ThrowOnError extends boolean = false>(options: Options<AddContactToPropertyHousesHouseIdContactsPostData, ThrowOnError>) {
        return (options.client ?? client).post<AddContactToPropertyHousesHouseIdContactsPostResponses, AddContactToPropertyHousesHouseIdContactsPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove Contact From Property
     *
     * Archive a contact at this property — a soft delete the owner can undo.
     *
     * The row stays with status "removed", keeping the owner's `override_*` corrections. It is
     * listed by `GET /houses/{house_id}/contacts/archived` and put back by
     * `POST /houses/{house_id}/contacts/{property_contact_id}/restore`.
     *
     * 409 when the contact is connected to the property. This used to revoke that access on the
     * way through, which took a real person's access as a side effect of tidying a list —
     * disconnect them first with `DELETE .../{property_contact_id}/trust`.
     */
    public static removeContactFromPropertyHousesHouseIdContactsPropertyContactIdDelete<ThrowOnError extends boolean = false>(options: Options<RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteResponses, RemoveContactFromPropertyHousesHouseIdContactsPropertyContactIdDeleteErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/{property_contact_id}',
            ...options
        });
    }
    
    /**
     * Update Property Contact
     *
     * Update property contact details.
     *
     * Can update:
     * - Service category
     * - Property-specific notes
     * - Trust status
     * - Party type (person / company)
     * - The owner's corrections to name, company, phone and email
     *
     * Partial: only the fields sent are written, and an explicit null clears an override.
     */
    public static updatePropertyContactHousesHouseIdContactsPropertyContactIdPut<ThrowOnError extends boolean = false>(options: Options<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutResponses, UpdatePropertyContactHousesHouseIdContactsPropertyContactIdPutErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/{property_contact_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Archived Property Contacts
     *
     * The contacts archived at this property, most recently archived first.
     *
     * Archiving is `DELETE /houses/{house_id}/contacts/{property_contact_id}` — a soft delete
     * that keeps the row and the owner's corrections. Put one back with
     * `POST /houses/{house_id}/contacts/{property_contact_id}/restore`.
     *
     * Gated on HOUSE_NETWORK_MANAGE for the same reason the discarded-candidates list is: the
     * only thing to do here is restore, and restore is MANAGE.
     *
     * Entries are the same `PropertyContactWithDetails` the active list returns, so one
     * component renders both. `status` is "removed" and `is_connected` is false, because archiving
     * refuses a connected contact.
     */
    public static listArchivedPropertyContactsHousesHouseIdContactsArchivedGet<ThrowOnError extends boolean = false>(options: Options<ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetResponses, ListArchivedPropertyContactsHousesHouseIdContactsArchivedGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/archived',
            ...options
        });
    }
    
    /**
     * Restore Contact To Property
     *
     * Bring an archived contact back to the property's list.
     *
     * It comes back **disconnected**: restore never grants house access, because access is a
     * deliberate act. Connect the contact again if that is still wanted. The owner's
     * `override_*` corrections come back with it — archiving never cleared them.
     *
     * 409 when the contact is not archived.
     */
    public static restoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePost<ThrowOnError extends boolean = false>(options: Options<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostData, ThrowOnError>) {
        return (options.client ?? client).post<RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostResponses, RestoreContactToPropertyHousesHouseIdContactsPropertyContactIdRestorePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/{property_contact_id}/restore',
            ...options
        });
    }
    
    /**
     * Accept Extracted Contact
     *
     * Accept an extracted contact and convert it to a confirmed contact.
     *
     * This endpoint:
     * - Creates a ProfessionalContact (or matches existing)
     * - Creates a PropertyContact association
     * - Marks the ExtractedContact as processed
     */
    public static acceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPost<ThrowOnError extends boolean = false>(options: Options<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostData, ThrowOnError>) {
        return (options.client ?? client).post<AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostResponses, AcceptExtractedContactHousesHouseIdContactsFromExtractionExtractedContactIdPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/from-extraction/{extracted_contact_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Contact Candidates
     *
     * The reconciler's pending candidates for this house, grouped Primary/Secondary, for
     * the review UI. Excluded (scope-filtered) and already-decided candidates are omitted.
     */
    public static listContactCandidatesHousesHouseIdContactsCandidatesGet<ThrowOnError extends boolean = false>(options: Options<ListContactCandidatesHousesHouseIdContactsCandidatesGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListContactCandidatesHousesHouseIdContactsCandidatesGetResponses, ListContactCandidatesHousesHouseIdContactsCandidatesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/candidates',
            ...options
        });
    }
    
    /**
     * List Contact Taxonomy
     *
     * The Category/Role taxonomy visible to this house — the 5 seeded groups plus this house's
     * own customs, each with its roles, ordered by hierarchy rank (§10). Feeds the FE's directory
     * filter and the "assign a role" picker.
     */
    public static listContactTaxonomyHousesHouseIdContactsTaxonomyGet<ThrowOnError extends boolean = false>(options: Options<ListContactTaxonomyHousesHouseIdContactsTaxonomyGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListContactTaxonomyHousesHouseIdContactsTaxonomyGetResponses, ListContactTaxonomyHousesHouseIdContactsTaxonomyGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/taxonomy',
            ...options
        });
    }
    
    /**
     * Create Custom Contact Category
     *
     * Author a house-scoped custom Category (the PM's "Category"). It joins this house's taxonomy
     * only, ranks after the seeded groups, and — being user-authored — the reconciler never touches
     * or auto-assigns it (§10).
     */
    public static createCustomContactCategoryHousesHouseIdContactsCategoriesPost<ThrowOnError extends boolean = false>(options: Options<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostResponses, CreateCustomContactCategoryHousesHouseIdContactsCategoriesPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Custom Contact Role
     *
     * Author a house-scoped custom Role under a Category the house can see (seeded or its own
     * custom). User-authored, so it always wins on a contact and the reconciler never emits it.
     */
    public static createCustomContactRoleHousesHouseIdContactsRolesPost<ThrowOnError extends boolean = false>(options: Options<CreateCustomContactRoleHousesHouseIdContactsRolesPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCustomContactRoleHousesHouseIdContactsRolesPostResponses, CreateCustomContactRoleHousesHouseIdContactsRolesPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/roles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Discarded Contact Candidates
     *
     * The candidates this owner has rejected, so the discard can be reviewed and undone.
     *
     * Read-only and deliberately separate from the review list: opening this cannot move
     * anything the review queue shows. Every entry is a full `ContactCandidateOut`, the same
     * shape a pending candidate has, so it renders with the same component; put one back with
     * `POST /houses/{house_id}/contacts/candidates/{extracted_contact_id}/undo`, which returns
     * it to pending and to the review list.
     *
     * Only the owner's own rejections. A candidate the reconciler filtered out is not here: it
     * carries `excluded` with a reason, nobody decided it, and there is no endpoint that could
     * put it back — the reconciler owns that column and re-derives it on every run.
     *
     * Gated on HOUSE_NETWORK_MANAGE, not the HOUSE_NETWORK_VIEW its sibling review list uses.
     * The only thing to do with this list is restore from it, and restore is MANAGE — so a
     * contributor, who holds VIEW but not MANAGE, would be shown a page of people they can do
     * nothing about. A saved contact is reference a contributor may need; a contact the owner
     * threw away is not, and it is a named third party the owner made a negative decision about.
     *
     * Unpaginated, like the review list it sits beside. A house's candidates number in the tens.
     */
    public static listDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGet<ThrowOnError extends boolean = false>(options: Options<ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetResponses, ListDiscardedContactCandidatesHousesHouseIdContactsCandidatesDiscardedGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/candidates/discarded',
            ...options
        });
    }
    
    /**
     * Edit Contact Candidate
     *
     * Correct a candidate before promoting it (7b). Only the fields sent are changed; the
     * candidate stays pending, and the edit survives reconciler re-runs and undo.
     */
    public static editContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatch<ThrowOnError extends boolean = false>(options: Options<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchData, ThrowOnError>) {
        return (options.client ?? client).patch<EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchResponses, EditContactCandidateHousesHouseIdContactsCandidatesExtractedContactIdPatchErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/candidates/{extracted_contact_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Undo Contact Decision
     *
     * Undo an accept or reject on a candidate, returning it to pending (it reappears in
     * the review list and on plan cards). Returns the reset candidate.
     */
    public static undoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPost<ThrowOnError extends boolean = false>(options: Options<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostData, ThrowOnError>) {
        return (options.client ?? client).post<UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostResponses, UndoContactDecisionHousesHouseIdContactsCandidatesExtractedContactIdUndoPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/candidates/{extracted_contact_id}/undo',
            ...options
        });
    }
    
    /**
     * Reject Extracted Contact
     *
     * Discard a candidate — it is marked rejected, never deleted.
     *
     * The body optionally says why, and is stored on the decision rather than on the candidate.
     * Both of its fields are optional, so discarding without a reason stays one call.
     *
     * A POST beside `/undo`, replacing `DELETE .../contacts/extracted/{id}`: a reason sent on a
     * DELETE body is dropped by clients that cannot send one — `axios.delete(url, data)` passes
     * it as config, and generators routinely omit a DELETE request body — and the loss is
     * silent, because an absent body and a stripped one are the same request.
     */
    public static rejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPost<ThrowOnError extends boolean = false>(options: Options<RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostData, ThrowOnError>) {
        return (options.client ?? client).post<RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostResponses, RejectExtractedContactHousesHouseIdContactsCandidatesExtractedContactIdDiscardPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/contacts/candidates/{extracted_contact_id}/discard',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class UserActivity {
    /**
     * Get User Activity
     *
     * What one user did on this property, newest first: documents they uploaded, tasks they
     * created, and the work they recorded on tasks — completions, skips, notes and attachments.
     *
     * Scoped to the current owner's tenure. Gated on HOUSE_ACCESS_MANAGEMENT_MANAGE, as the sharing
     * activity timeline is: it shows what other people did here, including the names of private
     * documents, which only an owner or a house admin may see.
     *
     * A user with no activity here, or no account at all, returns an empty page rather than a 404.
     */
    public static getUserActivityHousesHouseIdUsersUserIdActivityGet<ThrowOnError extends boolean = false>(options: Options<GetUserActivityHousesHouseIdUsersUserIdActivityGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetUserActivityHousesHouseIdUsersUserIdActivityGetResponses, GetUserActivityHousesHouseIdUsersUserIdActivityGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/users/{user_id}/activity',
            ...options
        });
    }
}

export class StripeWebhooks {
    /**
     * Stripe Webhook
     *
     * Main webhook endpoint for receiving Stripe events.
     *
     * Stripe sends webhook events when subscription-related actions occur:
     * - checkout.session.completed: User completed payment (critical - creates pool entries)
     * - customer.subscription.created: Subscription created (validation/logging)
     * - invoice.paid: Subscription renewed successfully (updates PropertySubscription)
     * - customer.subscription.updated: Subscription status changed (tracks failures, pauses)
     * - customer.subscription.deleted: Subscription canceled (marks properties as pending)
     *
     * All events are verified using Stripe's signature to prevent tampering.
     */
    public static stripeWebhookStripeWebhookPost<ThrowOnError extends boolean = false>(options?: Options<StripeWebhookStripeWebhookPostData, ThrowOnError>) {
        return (options?.client ?? client).post<StripeWebhookStripeWebhookPostResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/stripe/webhook',
            ...options
        });
    }
}

export class DocumentWebhooks {
    /**
     * Inbound Email
     *
     * Handle Postmark inbound email webhook.
     *
     * This endpoint:
     * 1. Authenticates the webhook request (HTTP Basic Auth)
     * 2. Logs sender-authentication evidence (DKIM/SPF headers) for the email
     * 3. Requires Postmark's SPF verdict to be an aligned pass for the sender
     * 4. Extracts the {alias}@INBOUND_EMAIL_DOMAIN recipient and resolves the house
     * 5. Validates the sender may upload to that house
     * 6. Enqueues a Celery task to process attachments
     *
     * Emails that fail resolution or validation get the uniform
     * REJECTED_RESPONSE with HTTP 200; the reason is only logged.
     *
     * Returns:
     * {"status": "ok", ...} when accepted, REJECTED_RESPONSE otherwise
     */
    public static inboundEmailHooksPostmarkInboundPost<ThrowOnError extends boolean = false>(options: Options<InboundEmailHooksPostmarkInboundPostData, ThrowOnError>) {
        return (options.client ?? client).post<InboundEmailHooksPostmarkInboundPostResponses, InboundEmailHooksPostmarkInboundPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'basic', type: 'http' }],
            url: '/hooks/postmark-inbound',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ApiKeys {
    /**
     * List Grantable Scopes
     *
     * What a key may be allowed to do, with a line of explanation for each.
     *
     * Declared before the route that takes a public id so the literal path wins the match
     * without depending on how a uuid converter treats the word "scopes".
     */
    public static listGrantableScopesUsersMeApiKeysScopesGet<ThrowOnError extends boolean = false>(options?: Options<ListGrantableScopesUsersMeApiKeysScopesGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ListGrantableScopesUsersMeApiKeysScopesGetResponses, ListGrantableScopesUsersMeApiKeysScopesGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/api-keys/scopes',
            ...options
        });
    }
    
    /**
     * List Keys
     *
     * Every key the caller has made, newest first.
     *
     * Revoked and expired ones are included with their status and timestamps: the list is
     * the owner's record of what they issued, not only of what still works, and "this key
     * stopped working on Tuesday" is exactly what someone comes here to find out.
     */
    public static listKeysUsersMeApiKeysGet<ThrowOnError extends boolean = false>(options?: Options<ListKeysUsersMeApiKeysGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ListKeysUsersMeApiKeysGetResponses, ListKeysUsersMeApiKeysGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/api-keys',
            ...options
        });
    }
    
    /**
     * Create Key
     *
     * Create a key and show its secret, once.
     *
     * The order matters. Everything that can refuse the request runs before anything is
     * written, and the response carrying the secret is built after the commit — so there is
     * no path where a person is shown a secret for a key that was rolled back.
     */
    public static createKeyUsersMeApiKeysPost<ThrowOnError extends boolean = false>(options: Options<CreateKeyUsersMeApiKeysPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateKeyUsersMeApiKeysPostResponses, CreateKeyUsersMeApiKeysPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/api-keys',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Revoke Key
     *
     * Stop a key working. Idempotent, and the row is kept.
     *
     * Revoking twice returns the same 204 and keeps the first timestamp, which is the moment
     * the key actually stopped working. A caller retrying after a dropped connection should
     * not be told they are wrong, and should not be able to move the record of when it
     * happened.
     */
    public static revokeKeyUsersMeApiKeysPublicIdDelete<ThrowOnError extends boolean = false>(options: Options<RevokeKeyUsersMeApiKeysPublicIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RevokeKeyUsersMeApiKeysPublicIdDeleteResponses, RevokeKeyUsersMeApiKeysPublicIdDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/api-keys/{public_id}',
            ...options
        });
    }
    
    /**
     * Get Key
     */
    public static getKeyUsersMeApiKeysPublicIdGet<ThrowOnError extends boolean = false>(options: Options<GetKeyUsersMeApiKeysPublicIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetKeyUsersMeApiKeysPublicIdGetResponses, GetKeyUsersMeApiKeysPublicIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/me/api-keys/{public_id}',
            ...options
        });
    }
}

export class OAuth {
    /**
     * Authorization Server Metadata
     *
     * How to ask this server for access (RFC 8414).
     *
     * Metered on the same per-address class as the token endpoint rather than a class of its
     * own: both are answered to a program before anybody is signed in, both are cheap, and one
     * ceiling over the pair is one thing to reason about during an incident. A client reads
     * this once and caches it, so the allowance is spent by probing rather than by use.
     */
    public static authorizationServerMetadataWellKnownOauthAuthorizationServerGet<ThrowOnError extends boolean = false>(options?: Options<AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetData, ThrowOnError>) {
        return (options?.client ?? client).get<AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetResponses, AuthorizationServerMetadataWellKnownOauthAuthorizationServerGetErrors, ThrowOnError>({
            responseType: 'json',
            url: '/.well-known/oauth-authorization-server',
            ...options
        });
    }
    
    /**
     * Register
     *
     * Register a client (RFC 7591). Open, and grants nothing.
     *
     * Open because a client that installs itself on somebody's machine has nobody to ask for
     * credentials, and closed registration would mean no such client could ever connect. A
     * registration reaches nothing at all on its own: it is a name and a list of addresses,
     * and every key it ever holds was approved by a person who read that name. The ceiling on
     * this route is what keeps the table from being somewhere to write rows for free.
     */
    public static registerOauthRegisterPost<ThrowOnError extends boolean = false>(options: Options<RegisterOauthRegisterPostData, ThrowOnError>) {
        return (options.client ?? client).post<RegisterOauthRegisterPostResponses, RegisterOauthRegisterPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/oauth/register',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove Registration
     *
     * The client removes itself (RFC 7592 section 2.3), and its keys go with it.
     *
     * Answers 204 and nothing else, as the specification requires. A second call is 401 like any
     * other call with a token that no longer names a live registration, which is also the answer
     * somebody guessing at ids gets, so the two cannot be told apart.
     *
     * **The keys it obtained are revoked.** An app announcing it is gone while the credentials it
     * was approved for keep working is the one outcome nobody would expect from "the app removed
     * its registration", so each one is revoked with an audit row saying why — the key page and
     * the trail both explain the change instead of showing a key that stopped for no reason.
     */
    public static removeRegistrationOauthRegisterClientIdDelete<ThrowOnError extends boolean = false>(options: Options<RemoveRegistrationOauthRegisterClientIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RemoveRegistrationOauthRegisterClientIdDeleteResponses, RemoveRegistrationOauthRegisterClientIdDeleteErrors, ThrowOnError>({ url: '/oauth/register/{client_id}', ...options });
    }
    
    /**
     * Read Registration
     *
     * What this client is registered as (RFC 7592 section 2.2).
     *
     * The registration access token is the authorization, and it is the only thing that is:
     * possession of it is what RFC 7592 intends for a client that has nobody to prove itself
     * to, and it is the same reasoning the revocation endpoint runs on.
     *
     * The answer does not echo the token back. A client presenting it already has it, and
     * repeating a live credential in the body of a plain GET would write it into every log and
     * proxy on the way.
     *
     * Metered on the registration class, like the route that creates one: these three routes are
     * one endpoint as far as a caller is concerned, and the tight allowance is what keeps
     * guessing at ids from being free.
     */
    public static readRegistrationOauthRegisterClientIdGet<ThrowOnError extends boolean = false>(options: Options<ReadRegistrationOauthRegisterClientIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<ReadRegistrationOauthRegisterClientIdGetResponses, ReadRegistrationOauthRegisterClientIdGetErrors, ThrowOnError>({
            responseType: 'json',
            url: '/oauth/register/{client_id}',
            ...options
        });
    }
    
    /**
     * Registration Is Not Editable
     *
     * Not implemented, and said in a sentence (RFC 7592 allows a server to refuse it).
     *
     * Declared as a route rather than left to the router, so a client library that tries to
     * update itself is told why and what to do instead, rather than getting the 405 a typo
     * would earn. It reads no token: there is nothing here to authorize, and looking one up
     * would make an unimplemented verb a way to test whether a token is good.
     */
    public static registrationIsNotEditableOauthRegisterClientIdPut<ThrowOnError extends boolean = false>(options: Options<RegistrationIsNotEditableOauthRegisterClientIdPutData, ThrowOnError>) {
        return (options.client ?? client).put<RegistrationIsNotEditableOauthRegisterClientIdPutResponses, RegistrationIsNotEditableOauthRegisterClientIdPutErrors, ThrowOnError>({
            responseType: 'json',
            url: '/oauth/register/{client_id}',
            ...options
        });
    }
    
    /**
     * Authorization Is Not Here
     *
     * Nothing arrives here any more. The authorization endpoint is the app's page.
     *
     * Kept as a route, rather than left to the router's own 404, so that a client holding
     * metadata from before the endpoint moved is told where to go instead of getting the same
     * blank answer it would get for a typo.
     */
    public static authorizationIsNotHereOauthAuthorizeGet<ThrowOnError extends boolean = false>(options?: Options<AuthorizationIsNotHereOauthAuthorizeGetData, ThrowOnError>) {
        return (options?.client ?? client).get<AuthorizationIsNotHereOauthAuthorizeGetResponses, AuthorizationIsNotHereOauthAuthorizeGetErrors, ThrowOnError>({
            responseType: 'json',
            url: '/oauth/authorize',
            ...options
        });
    }
    
    /**
     * Start Authorization
     *
     * Begin a request from the consent page, and answer what the page should show.
     *
     * The page is the authorization endpoint. It receives the client's parameters on its own
     * query string, and posts them here unread: this route validates every one of them, exactly
     * as the route a browser used to navigate to did, so the parameters are checked by this
     * service and never by a page. A page that validated them itself would be a second
     * implementation of the rules that decide where a code may be sent.
     *
     * Metered on the token class, as the navigated route was, because it is the same step of
     * the same flow; the session is what identifies the person, so there is nothing here for an
     * unauthenticated caller to spend.
     *
     * One round trip. The answer is the consent description itself rather than a request id to
     * fetch, because the page needs all of it before it can render anything, and a redirect for
     * a browser to follow is exactly what this route exists to stop being necessary.
     *
     * **No refusal is ever redirected.** The caller is a page of ours with a person looking at
     * it, so an error is JSON it shows verbatim; the client's address is not somewhere this
     * route sends anybody, whether or not the address validated.
     */
    public static startAuthorizationOauthAuthorizePost<ThrowOnError extends boolean = false>(options: Options<StartAuthorizationOauthAuthorizePostData, ThrowOnError>) {
        return (options.client ?? client).post<StartAuthorizationOauthAuthorizePostResponses, StartAuthorizationOauthAuthorizePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/oauth/authorize',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Describe Request
     *
     * What the consent page shows: who is asking, and what this person may grant.
     *
     * Session-authenticated, and the request must be this person's own — a request id names
     * the person it was created for and is not a capability for anybody else who learns it.
     *
     * The answer is shaped like the decision. ``scopes`` is the list once, because a consent is
     * one scope set applied to every property chosen, and ``properties`` says which of those
     * each property's role refuses, so the page can disable a box and name the property. There
     * is nothing to combine: what the person ticks is what the key carries.
     *
     * ``requested_scopes`` is kept separate from both. It is what the client asked for, and the
     * page ticks those of them this person's role allows, labelled as requested, with the rest
     * shown disabled and named. No property is chosen until the person chooses one, and the
     * duration opens on the shortest choice. Consent is the Approve button and not a tick box:
     * nothing is granted until it is pressed.
     */
    public static describeRequestOauthAuthorizeRequestIdGet<ThrowOnError extends boolean = false>(options: Options<DescribeRequestOauthAuthorizeRequestIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<DescribeRequestOauthAuthorizeRequestIdGetResponses, DescribeRequestOauthAuthorizeRequestIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/oauth/authorize/{request_id}',
            ...options
        });
    }
    
    /**
     * Approve
     *
     * Grant what the person chose: mint the key, and answer where to send the browser.
     *
     * Metered on the class that guards making a key from the key page, because that is what
     * this does. The secret is not in the answer and is not shown to the person at all: the
     * client collects it at the token endpoint in exchange for the code and its verifier, so
     * the one place it is ever seen is the one place it is needed.
     *
     * One scope list for every property named. An approval whose scopes the role on one of
     * those properties does not allow is refused, naming that property, rather than granted as
     * something narrower or wider than what was ticked.
     */
    public static approveOauthAuthorizeRequestIdApprovePost<ThrowOnError extends boolean = false>(options: Options<ApproveOauthAuthorizeRequestIdApprovePostData, ThrowOnError>) {
        return (options.client ?? client).post<ApproveOauthAuthorizeRequestIdApprovePostResponses, ApproveOauthAuthorizeRequestIdApprovePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/oauth/authorize/{request_id}/approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Refuse
     *
     * Say no, and tell the client so.
     *
     * The refusal goes back through the client's own address, so the app that asked can say
     * "you declined" instead of waiting on a window that never answers.
     */
    public static refuseOauthAuthorizeRequestIdRefusePost<ThrowOnError extends boolean = false>(options: Options<RefuseOauthAuthorizeRequestIdRefusePostData, ThrowOnError>) {
        return (options.client ?? client).post<RefuseOauthAuthorizeRequestIdRefusePostResponses, RefuseOauthAuthorizeRequestIdRefusePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/oauth/authorize/{request_id}/refuse',
            ...options
        });
    }
    
    /**
     * Token
     *
     * Trade a code, or a refresh token, for an access token and the next refresh token.
     *
     * Form-encoded, because that is what RFC 6749 specifies and what every client library
     * sends. ``no-store`` on every answer, including the refusals: a response carrying a
     * credential must not be written to a cache on the way past.
     *
     * The writes are committed before the answer is built, so there is no path where a client
     * is handed a secret for a rotation that was rolled back. The audit rows go the same way:
     * after the commit, and only for writes that survived it, so the trail never claims a
     * revocation that was rolled back.
     */
    public static tokenOauthTokenPost<ThrowOnError extends boolean = false>(options?: Options<TokenOauthTokenPostData, ThrowOnError>) {
        return (options?.client ?? client).post<TokenOauthTokenPostResponses, TokenOauthTokenPostErrors, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            responseType: 'json',
            url: '/oauth/token',
            ...options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options?.headers
            }
        });
    }
    
    /**
     * Revoke
     *
     * Revoke the key behind a token (RFC 7009).
     *
     * Answers 200 whether or not the token existed, which the specification requires and which
     * is also the only answer that does not turn this route into a way of finding out which
     * tokens are real. The hint is accepted and ignored: the token's own prefix says which kind
     * it is, and a hint that disagreed with the token would be a second opinion worth nothing.
     *
     * Possession of the token is the authorization. That is what the specification intends for
     * a public client, and the alternative — asking a client to prove itself — would leave a
     * person unable to disconnect an app whose registration has been pruned.
     */
    public static revokeOauthRevokePost<ThrowOnError extends boolean = false>(options?: Options<RevokeOauthRevokePostData, ThrowOnError>) {
        return (options?.client ?? client).post<RevokeOauthRevokePostResponses, RevokeOauthRevokePostErrors, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            responseType: 'json',
            url: '/oauth/revoke',
            ...options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options?.headers
            }
        });
    }
}

export class StagedDocuments {
    /**
     * List Staged Documents
     *
     * What is waiting on this property, newest first.
     *
     * Defaults to ``ready`` because that is the only state a person can do anything about;
     * the others are there for the question "what happened to the file my agent sent", which
     * is asked deliberately and rarely.
     */
    public static listStagedDocumentsHousesHouseIdStagedDocumentsGet<ThrowOnError extends boolean = false>(options: Options<ListStagedDocumentsHousesHouseIdStagedDocumentsGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListStagedDocumentsHousesHouseIdStagedDocumentsGetResponses, ListStagedDocumentsHousesHouseIdStagedDocumentsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents',
            ...options
        });
    }
    
    /**
     * List Bundle Proposals
     *
     * Groupings contributors have asked for on this property, with what is in each.
     *
     * The advisory occasion is shown as proposed and flagged as advisory, because approving
     * it is a separate act from approving the grouping.
     */
    public static listBundleProposalsHousesHouseIdStagedDocumentsProposalsGet<ThrowOnError extends boolean = false>(options: Options<ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetResponses, ListBundleProposalsHousesHouseIdStagedDocumentsProposalsGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents/proposals',
            ...options
        });
    }
    
    /**
     * Approve Bundle Proposal
     *
     * Accept the grouping. Every file still waiting for review goes in, as one bundle.
     */
    public static approveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePost<ThrowOnError extends boolean = false>(options: Options<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostData, ThrowOnError>) {
        return (options.client ?? client).post<ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostResponses, ApproveBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdApprovePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents/proposals/{public_id}/approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Refuse Bundle Proposal
     *
     * Say no to the grouping. The files stay exactly where they were.
     */
    public static refuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePost<ThrowOnError extends boolean = false>(options: Options<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostData, ThrowOnError>) {
        return (options.client ?? client).post<RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostResponses, RefuseBundleProposalHousesHouseIdStagedDocumentsProposalsPublicIdRefusePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents/proposals/{public_id}/refuse',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Staged Document
     */
    public static getStagedDocumentHousesHouseIdStagedDocumentsPublicIdGet<ThrowOnError extends boolean = false>(options: Options<GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetResponses, GetStagedDocumentHousesHouseIdStagedDocumentsPublicIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents/{public_id}',
            ...options
        });
    }
    
    /**
     * Promote Staged Document
     *
     * Accept one staged file into the property.
     */
    public static promoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePost<ThrowOnError extends boolean = false>(options: Options<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostData, ThrowOnError>) {
        return (options.client ?? client).post<PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostResponses, PromoteStagedDocumentHousesHouseIdStagedDocumentsPublicIdPromotePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents/{public_id}/promote',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Promote Staged Documents
     *
     * Accept several staged files at once, as one bundle when a spec is given.
     */
    public static promoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePost<ThrowOnError extends boolean = false>(options: Options<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostData, ThrowOnError>) {
        return (options.client ?? client).post<PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostResponses, PromoteStagedDocumentsHousesHouseIdStagedDocumentsPromotePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents/promote',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reject Staged Document
     *
     * Turn one staged file down. Its bytes are deleted.
     */
    public static rejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPost<ThrowOnError extends boolean = false>(options: Options<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostData, ThrowOnError>) {
        return (options.client ?? client).post<RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostResponses, RejectStagedDocumentHousesHouseIdStagedDocumentsPublicIdRejectPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents/{public_id}/reject',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reject Staged Documents
     *
     * Turn several staged files down at once.
     */
    public static rejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPost<ThrowOnError extends boolean = false>(options: Options<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostData, ThrowOnError>) {
        return (options.client ?? client).post<RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostResponses, RejectStagedDocumentsHousesHouseIdStagedDocumentsRejectPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/houses/{house_id}/staged-documents/reject',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Diagnostics {
    /**
     * Get Pool Stats
     *
     * Get current connection pool statistics
     */
    public static getPoolStatsDiagnosticsDbPoolStatsGet<ThrowOnError extends boolean = false>(options?: Options<GetPoolStatsDiagnosticsDbPoolStatsGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetPoolStatsDiagnosticsDbPoolStatsGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/diagnostics/db/pool-stats',
            ...options
        });
    }
    
    /**
     * Get Database Connections
     *
     * Get active database connections from PostgreSQL
     */
    public static getDatabaseConnectionsDiagnosticsDbConnectionsGet<ThrowOnError extends boolean = false>(options?: Options<GetDatabaseConnectionsDiagnosticsDbConnectionsGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetDatabaseConnectionsDiagnosticsDbConnectionsGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/diagnostics/db/connections',
            ...options
        });
    }
    
    /**
     * Get Long Running Connections
     *
     * Get potentially leaked long-running connections
     */
    public static getLongRunningConnectionsDiagnosticsDbLongRunningGet<ThrowOnError extends boolean = false>(options?: Options<GetLongRunningConnectionsDiagnosticsDbLongRunningGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetLongRunningConnectionsDiagnosticsDbLongRunningGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/diagnostics/db/long-running',
            ...options
        });
    }
    
    /**
     * Get Full Diagnostics
     *
     * Run complete database diagnostics
     */
    public static getFullDiagnosticsDiagnosticsDbFullReportGet<ThrowOnError extends boolean = false>(options?: Options<GetFullDiagnosticsDiagnosticsDbFullReportGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetFullDiagnosticsDiagnosticsDbFullReportGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/diagnostics/db/full-report',
            ...options
        });
    }
    
    /**
     * Run Stress Test
     *
     * Run connection pool stress test
     */
    public static runStressTestDiagnosticsDbStressTestPost<ThrowOnError extends boolean = false>(options?: Options<RunStressTestDiagnosticsDbStressTestPostData, ThrowOnError>) {
        return (options?.client ?? client).post<RunStressTestDiagnosticsDbStressTestPostResponses, RunStressTestDiagnosticsDbStressTestPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/diagnostics/db/stress-test',
            ...options
        });
    }
    
    /**
     * Get System Resources
     *
     * Get system resource usage
     */
    public static getSystemResourcesDiagnosticsSystemResourcesGet<ThrowOnError extends boolean = false>(options?: Options<GetSystemResourcesDiagnosticsSystemResourcesGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetSystemResourcesDiagnosticsSystemResourcesGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/diagnostics/system/resources',
            ...options
        });
    }
}

export class Observability {
    /**
     * Drain Rekicks Endpoint
     *
     * Drain eligible re-kicks IN THIS ENVIRONMENT (broker + Slack resolve here).
     *
     * `confirm=False` previews the eligible rows without dispatching or changing state;
     * `confirm=True` dispatches them and, with `resolve_incidents`, closes each linked
     * incident (audited to the admin's email). Returns per-row outcomes.
     */
    public static drainRekicksEndpointObservabilityRekicksDrainPost<ThrowOnError extends boolean = false>(options: Options<DrainRekicksEndpointObservabilityRekicksDrainPostData, ThrowOnError>) {
        return (options.client ?? client).post<DrainRekicksEndpointObservabilityRekicksDrainPostResponses, DrainRekicksEndpointObservabilityRekicksDrainPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rekicks/drain',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Rollouts Endpoint
     */
    public static listRolloutsEndpointObservabilityRolloutsGet<ThrowOnError extends boolean = false>(options?: Options<ListRolloutsEndpointObservabilityRolloutsGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ListRolloutsEndpointObservabilityRolloutsGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts',
            ...options
        });
    }
    
    /**
     * Create Rollout Endpoint
     *
     * Create a draft rollout (nothing materialised until it is locked).
     */
    public static createRolloutEndpointObservabilityRolloutsPost<ThrowOnError extends boolean = false>(options: Options<CreateRolloutEndpointObservabilityRolloutsPostData, ThrowOnError>) {
        return (options.client ?? client).post<CreateRolloutEndpointObservabilityRolloutsPostResponses, CreateRolloutEndpointObservabilityRolloutsPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Rollout Endpoint
     */
    public static getRolloutEndpointObservabilityRolloutsRolloutIdGet<ThrowOnError extends boolean = false>(options: Options<GetRolloutEndpointObservabilityRolloutsRolloutIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetRolloutEndpointObservabilityRolloutsRolloutIdGetResponses, GetRolloutEndpointObservabilityRolloutsRolloutIdGetErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts/{rollout_id}',
            ...options
        });
    }
    
    /**
     * Preview Rollout Endpoint
     *
     * The worklist this rollout would materialise — counts + waves — without writing.
     */
    public static previewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPost<ThrowOnError extends boolean = false>(options: Options<PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostData, ThrowOnError>) {
        return (options.client ?? client).post<PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostResponses, PreviewRolloutEndpointObservabilityRolloutsRolloutIdPreviewPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts/{rollout_id}/preview',
            ...options
        });
    }
    
    /**
     * Lock Rollout Endpoint
     *
     * Freeze the draft: materialise its held worklist and flip it to locked.
     */
    public static lockRolloutEndpointObservabilityRolloutsRolloutIdLockPost<ThrowOnError extends boolean = false>(options: Options<LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostData, ThrowOnError>) {
        return (options.client ?? client).post<LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostResponses, LockRolloutEndpointObservabilityRolloutsRolloutIdLockPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts/{rollout_id}/lock',
            ...options
        });
    }
    
    /**
     * Release Rollout Endpoint
     *
     * Operator-pump: advance this rollout by one wave now (optionally approving a
     * checkpoint wave first). The gate still applies — a closed gate reports why.
     */
    public static releaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePost<ThrowOnError extends boolean = false>(options: Options<ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostData, ThrowOnError>) {
        return (options.client ?? client).post<ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostResponses, ReleaseRolloutEndpointObservabilityRolloutsRolloutIdReleasePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts/{rollout_id}/release',
            ...options
        });
    }
    
    /**
     * Pause Rollout Endpoint
     */
    public static pauseRolloutEndpointObservabilityRolloutsRolloutIdPausePost<ThrowOnError extends boolean = false>(options: Options<PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostData, ThrowOnError>) {
        return (options.client ?? client).post<PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostResponses, PauseRolloutEndpointObservabilityRolloutsRolloutIdPausePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts/{rollout_id}/pause',
            ...options
        });
    }
    
    /**
     * Resume Rollout Endpoint
     */
    public static resumeRolloutEndpointObservabilityRolloutsRolloutIdResumePost<ThrowOnError extends boolean = false>(options: Options<ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostData, ThrowOnError>) {
        return (options.client ?? client).post<ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostResponses, ResumeRolloutEndpointObservabilityRolloutsRolloutIdResumePostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts/{rollout_id}/resume',
            ...options
        });
    }
    
    /**
     * Abort Rollout Endpoint
     */
    public static abortRolloutEndpointObservabilityRolloutsRolloutIdAbortPost<ThrowOnError extends boolean = false>(options: Options<AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostData, ThrowOnError>) {
        return (options.client ?? client).post<AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostResponses, AbortRolloutEndpointObservabilityRolloutsRolloutIdAbortPostErrors, ThrowOnError>({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/observability/rollouts/{rollout_id}/abort',
            ...options
        });
    }
    
    /**
     * Ingest Deploy
     *
     * Upsert one deploy record (idempotent on merge_sha). Called by the prod deploy job.
     */
    public static ingestDeployObservabilityDeploysPost<ThrowOnError extends boolean = false>(options: Options<IngestDeployObservabilityDeploysPostData, ThrowOnError>) {
        return (options.client ?? client).post<IngestDeployObservabilityDeploysPostResponses, IngestDeployObservabilityDeploysPostErrors, ThrowOnError>({
            responseType: 'json',
            url: '/observability/deploys',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SlackIntake {
    /**
     * Slash Command
     *
     * `/incident` — for a report with no conversation behind it.
     *
     * A custom slash command cannot be invoked inside a thread at all (Slack reserves that
     * for its own built-ins) and its payload carries no thread reference, so this path
     * never has conversation context to capture. Anything discussed in a thread is filed
     * with the message shortcut instead.
     */
    public static slashCommandObservabilitySlackCommandPost<ThrowOnError extends boolean = false>(options?: Options<SlashCommandObservabilitySlackCommandPostData, ThrowOnError>) {
        return (options?.client ?? client).post<SlashCommandObservabilitySlackCommandPostResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/observability/slack/command',
            ...options
        });
    }
    
    /**
     * Interactivity
     *
     * Shortcuts and modal submissions. Slack posts both here as a form-encoded
     * `payload`.
     */
    public static interactivityObservabilitySlackInteractivityPost<ThrowOnError extends boolean = false>(options?: Options<InteractivityObservabilitySlackInteractivityPostData, ThrowOnError>) {
        return (options?.client ?? client).post<InteractivityObservabilitySlackInteractivityPostResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/observability/slack/interactivity',
            ...options
        });
    }
}

export class Health {
    /**
     * Health Check
     *
     * Public health check endpoint for basic liveness probe.
     *
     * This is a lightweight endpoint with no external dependencies.
     * Use for:
     * - Kubernetes/Docker liveness probes
     * - Load balancer health checks
     * - Public status pages
     *
     * Returns 200 if the application is running.
     */
    public static healthCheckHealthGet<ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>) {
        return (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/health',
            ...options
        });
    }
    
    /**
     * Readiness Check
     *
     * Private readiness check endpoint with authentication.
     *
     * Validates that critical dependencies are operational.
     * Use for:
     * - CI/CD deployment validation
     * - Kubernetes readiness probes
     * - Internal monitoring
     *
     * Requires x-health-token header matching CORE_HEALTH_TOKEN.
     *
     * TODO: Add dependency checks for:
     * - Database connectivity
     * - Redis connectivity
     * - S3 connectivity
     *
     * Returns:
     * - 200: All systems ready
     * - 401: Invalid or missing health token
     * - 503: Dependencies not ready (to be implemented)
     */
    public static readinessCheckGreenthumbGet<ThrowOnError extends boolean = false>(options?: Options<ReadinessCheckGreenthumbGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ReadinessCheckGreenthumbGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/greenthumb',
            ...options
        });
    }
}

export class Default {
    /**
     * Read Root
     */
    public static readRootGet<ThrowOnError extends boolean = false>(options?: Options<ReadRootGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ReadRootGetResponses, unknown, ThrowOnError>({
            responseType: 'json',
            url: '/',
            ...options
        });
    }
}
